/**
 * القاموس العربي — وهو **مصدر المفاتيح** لكل النظام.
 *
 * `TranslationKey` مشتقّ من هذا الكائن، فأي مفتاح غير موجود هنا يصير خطأ ترجمة
 * وقت البناء، لا نصّاً فارغاً وقت التشغيل. وملف الإنجليزية مُلزَم بأن يحمل
 * المفاتيح نفسها بالضبط — ناقصٌ واحد يكسر البناء.
 *
 * الأرقام غربية (123) في اللغتين — قرار البلوبرنت §11.
 */
export const ar = {
    // ---------- عام ----------
    "common.save": "حفظ",
    "common.cancel": "إلغاء",
    "common.delete": "حذف",
    "common.edit": "تعديل",
    "common.nameAr": "الاسم بالعربية",
    "common.nameEn": "الاسم بالإنجليزية",
    "common.add": "إضافة",
    "brand.credit": "منوال من TWING",
    "common.close": "إغلاق",
    "paging.shown": "معروض {shown} من {total}",
    "paging.more": "اعرض {n} أخرى",
    "paging.invalid": "رقم الصفحة غير صحيح — حدّث الشاشة وحاول مرة أخرى",
    "common.back": "رجوع",
    "common.yes": "نعم",
    "common.no": "لا",
    "plans.periodLabel": "الفترة",
    "common.retry": "إعادة المحاولة",
    "common.confirm": "تأكيد",
    "common.search": "بحث",
    "common.showPassword": "إظهار كلمة السر",
    "common.hidePassword": "إخفاء كلمة السر",
    // ---------- الحالات الأربع — ترسمها القوقعة لكل شاشة ----------
    "state.crashed.title": "تعطّلت الشاشة",
    "state.crashed.quote": "أرسل لنا الرمز ورقم المرجع أعلاه — بهما نصل إلى العطل بدقة.",
    "state.crashed.reload": "أعِد تحميل الصفحة",
    "state.loading.title": "جارٍ التحميل…",
    "state.error.title": "تعذّر تحميل هذه الشاشة",
    "state.error.body": "حدث خطأ من جهتنا، لا من جهتك. حاول مرة أخرى — وإن تكرّر، أرسل الرمز ورقم المرجع أدناه.",
    "state.error.bodyRequest": "وإن احتجت إلى مساعدة، أرسل هذا الرمز ورقم المرجع.",
    "state.error.reference": "رقم المرجع",
    "state.error.code": "رمز الخطأ",
    "state.forbidden.title": "لا تملك هذه الصلاحية",
    "state.forbidden.body": "يمكنك طلبها، وسيصل الطلب إلى رئيس قسمك مباشرةً.",
    "state.forbidden.request": "اطلب الصلاحية",
    "state.forbidden.requested": "أُرسل الطلب — وسيصلك الرد هنا",
    "state.empty.title": "لا يوجد شيء هنا بعد",
    "state.empty.body": "ما تضيفه سيظهر في هذا المكان.",
    // ---------- الأخطاء — كل مفتاح هنا يقابل كوداً في كتالوج الأخطاء ----------
    "errors.internal": "حدث خطأ غير متوقّع من جهتنا. سُجّل، وسنراجعه.",
    "errors.appUpdated": "صدرت نسخة جديدة من النظام — حدِّث الصفحة لتكمل.",
    "errors.validationFailed": "توجد بيانات ناقصة أو غير صحيحة — راجع الحقول المعلّمة.",
    "errors.notFound": "ما تبحث عنه غير موجود، أو أُزيل.",
    "errors.conflict": "عدّل شخصٌ آخر العنصر نفسه قبلك. حدّث الصفحة وحاول مرة أخرى.",
    "errors.versionConflict": "النسخة التي تعمل عليها قديمة — حدّث الصفحة لترى آخر تعديل.",
    "errors.rateLimited": "محاولات كثيرة في وقت قصير. انتظر قليلاً وحاول مرة أخرى.",
    "errors.sessionInvalid": "انتهت جلستك. سجّل الدخول مرة أخرى.",
    "errors.passwordChangeRequired": "يجب أن تغيّر كلمة السر قبل المتابعة.",
    "errors.forbidden": "لا تملك هذه الصلاحية.",
    "errors.scopeForbidden": "تملك هذه الصلاحية، لكن ليس على هذا السجل تحديداً.",
    "errors.stepUpRequired": "هذه عملية مهمة — أكّد هويتك قبل المتابعة.",
    "errors.idempotencyKeyMissing": "وصل الطلب دون مفتاح الحماية من التكرار.",
    "errors.idempotencyKeyReused": "أُرسل المفتاح نفسه ببيانات مختلفة — هذه محاولة تكرار غير مكتملة.",
    "errors.storageQuotaExceeded": "مساحة العميل {quotaGb} جيجا، المستخدَم منها {usedGb}، والملف {incomingMb} ميجا. احذف ملفات أو زِد المساحة.",
    "errors.fileTypeNotAllowed": "نوع الملف هذا غير مسموح به: {contentType}",
    "errors.fileTooLarge": "حجم الملف {sizeMb} ميجا، والحد الأقصى لدينا {limitMb} ميجا.",
    "errors.fileScanPending": "ما زال الملف قيد الفحص — انتظر بضع ثوانٍ وحاول مرة أخرى.",
    "errors.fileInfected": "عثر الفحص على برمجية خبيثة في هذا الملف ({signature}) — فرُفض وحُذف.",
    "errors.overrideTooLong": "أقصى مدة للاستثناء {maxDays, plural, one {يوم واحد} two {يومان} few {# أيام} many {# يوماً} other {# يوم}}، وأنت تطلب {requestedDays}.",
    "overrides.windowInvalid": "تواريخ الاستثناء غير صحيحة.",
    "overrides.startsInPast": "لا يمكن أن يبدأ الاستثناء في الماضي.",
    "overrides.endsBeforeStart": "يجب أن يكون تاريخ النهاية بعد البداية.",
    "overrides.reasonRequired": "اكتب سبب الاستثناء — لتمكن مراجعته لاحقاً.",
    "roles.created": "أُنشئ الدور.",
    "roles.renamed": "حُفظ اسم الدور.",
    "roles.matrixSaved": "حُفظت مصفوفة الصلاحيات.",
    "roles.deleted": "حُذف الدور.",
    "roles.assigned": "أُسند الدور.",
    "overrides.created": "سُجّل الاستثناء بمدّته.",
    "overrides.removed": "أُزيل الاستثناء.",
    "roles.matrixRequired": "المصفوفة ناقصة.",
    "roles.capabilityUnknown": "توجد صلاحية غير معروفة في المصفوفة.",
    "roles.duplicateRow": "كُتبت الصلاحية نفسها مرتين بالنطاق نفسه.",
    "roles.departmentScopeEmpty": "اختر القسم — نطاق «قسم» دون قسم يعني «لا شيء».",
    "roles.explicitScopeNotOnRole": "نطاق «سجلات محدّدة» يُمنح لشخص، لا لدور.",
    "roles.nameRequired": "يجب أن يكون للدور اسم.",
    "people.created": "أُضيف الموظف، ووصله إشعار بحسابه.",
    "people.saved": "حُفظت بيانات الموظف.",
    "people.deactivated": "أُوقف الموظف، وانتقلت أعماله المفتوحة إلى رئيس قسمه.",
    "people.reactivated": "عاد الموظف نشطاً.",
    "people.deleted": "حُذف الموظف — ويبقى اسمه في السجل.",
    "people.passwordReset": "أُعيد تعيين كلمة السرّ، ووصله إشعار.",
    "people.sessionsRevoked": "أُغلقت كل جلساته.",
    "people.notAnEmployee": "هذا حساب جهة اتصال لدى عميل، لا موظف — لا يمكن اختياره لعمل داخلي.",
    "people.nameRequired": "يجب أن يتكوّن اسم الموظف من حرفين على الأقل.",
    "people.emailInvalid": "البريد غير صحيح.",
    "people.departmentRequired": "اختر قسماً واحداً على الأقل.",
    "people.tooManyDepartments": "أقصى عدد أقسام للشخص ثمانية.",
    "people.nothingToChange": "لم يتغيّر شيء.",
    "org.departmentCreated": "أُنشئ القسم.",
    "org.create": "قسم جديد",
    "org.nameAr": "اسم القسم بالعربية",
    "org.nameEn": "اسم القسم بالإنجليزية",
    "org.departmentSaved": "حُفظ القسم.",
    "org.departmentArchived": "أُرشف القسم.",
    "org.delegated": "سُجّل التفويض، ووصل إشعار للطرفين.",
    "org.delegationRevoked": "سُحب التفويض، وأُغلقت جلسات المفوَّض.",
    "org.nameRequired": "يجب أن يتكوّن اسم القسم من حرفين على الأقل.",
    "org.nothingToChange": "لم يتغيّر شيء.",
    "org.headMustBeActive": "يجب أن يكون رئيس القسم موظفاً نشطاً.",
    "org.headMustBeMember": "يجب أن يكون رئيس القسم من القسم نفسه.",
    "org.delegateIsHead": "هذا هو رئيس القسم بالفعل — لا يحتاج إلى تفويض.",
    "org.delegateMustBeActive": "يجب أن يكون المفوَّض موظفاً نشطاً.",
    "org.delegateMustBeMember": "يجب أن يكون المفوَّض من القسم.",
    "org.delegationReasonRequired": "اكتب سبب التفويض — لتمكن مراجعته لاحقاً.",
    "org.delegationWindowInvalid": "تواريخ التفويض غير صحيحة.",
    "org.delegationStartsInPast": "لا يمكن أن يبدأ التفويض في الماضي.",
    "org.delegationEndsBeforeStart": "يجب أن يكون تاريخ النهاية بعد البداية.",
    "org.delegationTooLong": "أقصى مدة للتفويض تسعون يوماً.",
    "access.reason": "لماذا تحتاجها؟",
    "access.reasonHint": "اكتب سطراً على الأقل يوضّح سبب حاجتك — هذا ما سيُقرأ عند اتخاذ القرار.",
    "access.requested": "أُرسل الطلب إلى رئيس قسمك.",
    "access.withdrawn": "سُحب الطلب.",
    "access.resolved": "سُجّل القرار، ووصل إشعار لصاحب الطلب.",
    "access.capabilityUnknown": "هذه الصلاحية غير موجودة.",
    "access.scopeNotAllowed": "هذا النطاق غير مسموح لهذه الصلاحية.",
    "access.departmentScopeEmpty": "اختر القسم.",
    "access.rejectionNeedsReason": "اكتب سبب الرفض — ليفهم صاحب الطلب.",
    "people.title": "الموظفون",
    "people.add": "أضِف موظفاً",
    "people.filter": "تصفية",
    "people.all": "الكل",
    "people.active": "نشط",
    "people.inactive": "موقوف",
    "people.stopped": "موقوف",
    "people.noRole": "بلا دور",
    "people.detail": "ملفّ الموظف",
    "people.email": "البريد",
    "people.departments": "الأقسام",
    "people.overrides": "استثناءات الصلاحية",
    "people.noOverrides": "لا توجد استثناءات.",
    "people.granted": "ممنوحة",
    "people.name": "الاسم",
    "people.viewAsPick": "اختر موظفاً غيرك.",
    "people.viewAsInactive": "هذا الموظف موقوف ولا يمكن الدخول بعينه.",
    "people.jobTitle": "اللقب الوظيفي",
    "people.jobTitleHint": "يظهر مع الاسم ولا يمنح أي صلاحية. الصلاحيات من الدور.",
    "people.editDetails": "عدّل الاسم والأقسام",
    "people.firstDepartmentPrimary": "أول قسم تختاره هو قسمه الأساسي.",
    "people.addOverride": "استثناء",
    "people.overrideCapability": "الصلاحية",
    "people.overridePick": "اختر صلاحية…",
    "people.overrideEffect": "منح أم سحب",
    "people.overrideScope": "على أي نطاق",
    "people.overrideReason": "السبب — سيُسجَّل وسيطّلع عليه صاحب الحساب",
    "people.overrideExpires": "ينتهي في",
    "people.removeOverride": "اسحبه",
    "people.confirmRemoveOverride": "سحب هذا الاستثناء الآن؟ ستعود الصلاحية كما يحددها دوره.",
    "people.delete": "احذف الموظف",
    "people.deleteConfirm": "سيُحذف «{name}» من النظام — سيُغلق دخوله، ويبقى اسمه في السجل وعلى أعماله السابقة.",
    "roles.delete": "احذف الدور",
    "roles.deleteConfirm": "سيُحذف الدور «{name}» بصلاحياته.",
    "roles.deleteBlocked": "يحمل هذا الدور {n, plural, one {موظف واحد — انقله} two {موظفان — انقلهما} few {# موظفين — انقلهم} many {# موظفاً — انقلهم} other {# موظف — انقلهم}} إلى دور آخر أولاً لتتمكن من حذفه.",
    "org.rename": "غيّر اسم القسم",
    "org.archive": "أرشِف القسم",
    "org.archiveConfirm": "سيُؤرشف القسم «{name}» نهائياً — ولن يظهر في القوائم ولا في الصلاحيات.",
    "org.archiveBlocked": "في القسم {n, plural, one {موظف واحد — انقله} two {موظفان — انقلهما} few {# موظفين — انقلهم} many {# موظفاً — انقلهم} other {# موظف — انقلهم}} أولاً لتتمكن من أرشفته.",
    "org.changeHead": "رئيس القسم",
    "org.changeHeadAction": "غيّر رئيس القسم",
    "people.revoked": "ممنوعة",
    "people.expired": "منتهية",
    "people.stop": "أوقِفه مؤقتاً",
    "people.restore": "أعِده",
    "people.resetPassword": "أعِد تعيين كلمة السرّ",
    "people.endSessions": "أغلق كل الأجهزة التي يدخل منها · {n, plural, one {جهاز واحد} two {جهازان} few {# أجهزة} many {# جهازاً} other {# جهاز}}",
    "people.confirmStop": "إيقاف هذا الموظف؟ ستنتقل أعماله المفتوحة إلى رئيس قسمه، وستُغلق جلساته.",
    "people.confirmReset": "إعادة تعيين كلمة سرّه؟ سيصله إشعار، وستُغلق جلساته.",
    "people.nameField": "اسم الموظف",
    "people.emptyTitle": "لا يوجد موظفون هنا",
    "people.emptyBody": "سيظهر الموظف في القائمة فور إضافته.",
    "nav.people": "الموظفون",
    "roles.title": "الأدوار",
    "roles.holders": "{n, plural, one {موظف واحد} two {موظفان} few {# موظفين} many {# موظفاً} other {# موظف}}",
    "roles.contactHolders": "{n, plural, one {جهة اتصال واحدة} two {جهتا اتصال} few {# جهات اتصال} many {# جهة اتصال} other {# جهة اتصال}}",
    "roles.capabilityCount": "{n, plural, one {صلاحية واحدة} two {صلاحيتان} few {# صلاحيات} many {# صلاحية} other {# صلاحية}}",
    "roles.portal": "دور بوابة العميل",
    "roles.create": "دور جديد",
    "roles.saveName": "احفظ الاسم",
    "roles.approveMatrix": "اعتمد المصفوفة",
    "roles.chosen": "{n} من {of}",
    "roles.module.plans": "الخطط",
    "roles.module.tasks": "المهام",
    "roles.module.cards": "البطاقات",
    "roles.module.boards": "اللوحات",
    "roles.module.clients": "العملاء",
    "roles.module.chat": "المحادثات",
    "roles.module.meetings": "الاجتماعات",
    "roles.module.reports": "التقارير",
    "roles.module.analytics": "التحليلات",
    "roles.module.moderation": "النشر",
    "roles.module.portal": "بوابة العميل",
    "roles.module.notifications": "الإشعارات والإجراءات",
    "roles.module.identity": "الموظفون",
    "roles.module.roles": "الأدوار والصلاحيات",
    "roles.module.organization": "الأقسام",
    "roles.module.access_requests": "طلبات الصلاحية",
    "roles.module.platform": "النظام",
    "roles.module.other": "أخرى",
    "roles.moduleHint.plans": "الخطط الشهرية وعناصرها ومهامها وقرارات العميل",
    "roles.moduleHint.tasks": "المهام الداخلية وتعليقاتها ومرفقاتها",
    "roles.moduleHint.cards": "العمل اليومي على البطاقات ومواعيدها",
    "roles.moduleHint.boards": "اللوحات وقوالبها",
    "roles.moduleHint.clients": "بيانات العميل وفريقه ومساحته",
    "roles.moduleHint.chat": "القنوات والرسائل",
    "roles.moduleHint.meetings": "طلبات اجتماعات العملاء والبتّ فيها",
    "roles.moduleHint.reports": "تقارير العملاء الشهرية ومراجعتها",
    "roles.moduleHint.analytics": "الأرقام والترتيب وأهداف الشركة",
    "roles.moduleHint.moderation": "طابور النشر ومواعيده وإثباته",
    "roles.moduleHint.portal": "ما يمكن لجهة اتصال العميل فعله",
    "roles.moduleHint.notifications": "إشعاراتك والإجراءات التي تنتظرك",
    "roles.moduleHint.identity": "ملفّات الموظفين وحساباتهم وأمانها",
    "roles.moduleHint.roles": "الأدوار ومصفوفاتها والاستثناءات الفردية",
    "roles.moduleHint.organization": "الأقسام ورؤساؤها والتفويض",
    "roles.moduleHint.access_requests": "طلب صلاحية والبتّ فيها",
    "roles.moduleHint.platform": "صحة النظام وسجلّه وإعداداته",
    "roles.moduleHint.other": "صلاحيات من غير مجموعة",
    "roles.lead": "اختر ما يستطيع هذا الدور فعله، ونطاقه: على الشركة كلها، أو قسمه، أو عملاءه فقط. يصل التغيير إلى كل من يحمل الدور فور اعتماده.",
    "roles.chosenOf": "{n, plural, one {صلاحية واحدة} two {صلاحيتان} few {# صلاحيات} many {# صلاحية} other {# صلاحية}} من {of}",
    "roles.rename": "غيّر الاسم",
    "roles.more": "خيارات الدور",
    "roles.pending": "{n, plural, one {تغيير واحد غير معتمد} two {تغييران غير معتمدَين} few {# تغييرات غير معتمدة} many {# تغييراً غير معتمد} other {# تغيير غير معتمد}} — سيصل إلى {holders, plural, one {موظف واحد} two {موظفَين} few {# موظفين} many {# موظفاً} other {# موظف}}",
    "roles.noPending": "لا يوجد تغيير بانتظار الاعتماد.",
    "roles.discard": "ألغِ التغييرات",
    "roles.pick": "اختر دوراً من القائمة لتعرض صلاحياته.",
    "roles.cannotGrant": "لا تملك منحها",
    "roles.scopeFor": "نطاق {capability}",
    "scope.company": "على الشركة كلها",
    "scope.headed": "على الأقسام التي يرأسها",
    "scope.member": "على أقسامه",
    "scope.assignee": "على ما كُلِّف به",
    "scope.creator": "على ما أنشأه",
    "scope.own": "على سجلّه الخاص",
    "scope.client": "على عملائه المسندين",
    "nav.roles": "الأدوار",
    "org.title": "الأقسام",
    "org.detail": "القسم",
    "org.head": "رئيس القسم",
    "org.noHead": "بلا رئيس",
    "org.members": "الأعضاء",
    "org.memberCount": "{n, plural, one {عضو واحد} two {عضوان} few {# أعضاء} many {# عضواً} other {# عضو}}",
    "org.delegations": "التفويضات",
    "org.noDelegations": "لا توجد تفويضات.",
    "org.delegationActive": "سارٍ",
    "org.delegationScheduled": "مجدول",
    "org.delegationEnded": "انتهى",
    "org.delegate": "فوّض شخصاً مكانه",
    "org.delegateTo": "المفوَّض",
    "org.revoke": "اسحب",
    "org.until": "حتى {when}",
    "org.reason": "السبب",
    "org.confirmRevoke": "سحب التفويض؟ ستُغلق جلسات المفوَّض.",
    "org.countLine": "{n, plural, one {قسم واحد} two {قسمان} few {# أقسام} many {# قسماً} other {# قسم}}",
    "org.delegatedLine": "{n} فوّض رئيسه شخصاً مكانه",
    "org.holdingUntil": "ينوب عنه حتى {when}",
    "org.revokeDelegation": "ألغِ التفويض",
    "org.more": "خيارات قسم {name}",
    "org.note": "يمنح التفويضُ النائبَ صلاحيات الرئيس على هذا القسم فقط، وحتى التاريخ الذي تحدده. وتُقفَل الأرشفة إذا كان في القسم أعضاء — انقلهم أولاً.",
    "org.open": "افتح قسم {name}",
    "nav.departments": "الأقسام",
    "access.title": "طلبات الصلاحيات",
    "preview.privateSection": "هذا الجزء خاص بصاحب الحساب، ولا يظهر عند النظر بعينه.",
    "attachments.remember": "ستُرفع هذه الملفات بعد الحفظ:",
    "access.subtitleMine": "الصلاحيات التي طلبتها وما قُرّر فيها. وعندما يُرفض لك إجراء، تطلبها من الشاشة نفسها.",
    "person.open": "بطاقة {name}",
    "person.card": "بطاقة الشخص",
    "person.message": "راسله",
    "person.online": "متّصل الآن",
    "person.away": "بعيد",
    "person.offline": "غير متّصل",
    "person.stopped": "موقوف",
    "chat.previewFailed": "تعذّر عرض هذا الملف. يمكنك تنزيله.",
    "mention.empty": "لا يوجد اسم مطابق",
    "mention.department": "قسم",
    "mention.list": "من تريد الإشارة إليه",
    "date.pick": "اختر التاريخ",
    "date.pickTime": "اختر التاريخ والوقت",
    "date.prevMonth": "الشهر السابق",
    "date.nextMonth": "الشهر التالي",
    "date.today": "اليوم",
    "date.clear": "مسح",
    "date.done": "تم",
    "date.hour": "الساعة",
    "date.minute": "الدقيقة",
    "date.am": "ص",
    "date.pm": "م",
    "date.prevYear": "السنة السابقة",
    "date.nextYear": "السنة التالية",
    "dialog.discard": "لديك نص لم يُحفظ. هل تريد الإغلاق دون حفظ؟",
    "access.subtitle": "عندما يضغط أحد على شيء خارج صلاحياته، يطلبه من هنا — وأنت تقرّر.",
    "access.tabs": "تبويبات",
    "access.queue": "بانتظار قراري",
    "access.mine": "طلباتي",
    "access.pending": "بانتظار القرار",
    "access.approved": "تمّت الموافقة",
    "access.rejected": "رُفض",
    "access.withdrawnStatus": "سُحب",
    "access.withdraw": "اسحب طلبي",
    "access.approve": "وافق",
    "access.reject": "ارفض",
    "access.note": "ردّك (سيصله)",
    "access.decisionBy": "قرار {name}",
    "access.noneMineTitle": "لم تطلب شيئاً بعد",
    "access.noneMineBody": "عندما يُرفض لك إجراء، ستجد زرّ طلب الصلاحية في الشاشة نفسها.",
    "access.noneQueueTitle": "لا توجد طلبات بالانتظار",
    "access.noneQueueBody": "ستظهر هنا طلبات الصلاحية من فريقك فور إرسالها.",
    "access.queueCount": "بانتظار قراري · {n}",
    "access.mineCount": "طلباتي · {n}",
    "access.mineWhen": "طلبي · {when}",
    "access.wantsLead": "يطلب:",
    "access.scopeOneDepartment": "على قسم محدّد",
    "access.scopeDepartments": "على {n, plural, one {قسم واحد محدّد} two {قسمَين محدّدَين} few {# أقسام محدّدة} many {# قسماً محدّداً} other {# قسم محدّد}}",
    "access.reasonQuote": "«{reason}»",
    "access.notePlaceholder": "مثلاً: موافق حتى يعود زميلك",
    "nav.access": "طلبات الصلاحيات",
    "errors.backupUnusable": "وجهة النسخ الاحتياطي «{bucket}» لا تعمل: {detail}",
    "setup.backupVerified": "جُرّبت الوجهة وهي تعمل — كتبنا ملفاً وقرأناه وحذفناه.",
    "setup.done": "اكتمل إعداد النظام. يمكنك الدخول بحسابك الآن.",
    "setup.required": "هذا الحقل مطلوب.",
    "setup.step.identity": "هوية النظام",
    "setup.step.owner": "حساب المالك",
    "setup.step.departments": "الأقسام",
    "setup.step.backup": "النسخة الاحتياطية",
    "setup.stepOf": "الخطوة {n} من 4",
    "setup.livePreview": "معاينة حيّة — تتغيّر أثناء الكتابة",
    "setup.changeLater": "يمكنك تغيير كل ما هنا لاحقاً من الإعدادات — ما عدا حساب المالك الأول.",
    "setup.namePlaceholder": "اسم نظامك",
    "setup.identityTitle": "نظامك باسمك ولونك",
    "setup.identityBody": "هذا ما سيراه فريقك وعملاؤك في كل شاشة.",
    "setup.systemName": "اسم النظام",
    "setup.accent": "لون الهوية",
    "setup.locale": "لغة النظام الأساسية",
    "setup.timezone": "التوقيت",
    "setup.ownerTitle": "حساب المالك",
    "setup.ownerBody": "هذا أول حساب في النظام، ويملك كل الصلاحيات. بعد ذلك أضِف فريقك من شاشة الموظفين.",
    "setup.ownerName": "الاسم",
    "setup.passwordRule": "١٢ حرفاً أو أكثر — الجملة الطويلة أفضل من كلمة معقّدة.",
    "setup.departmentsTitle": "أقسام الوكالة",
    "setup.departmentsBody": "الأقسام تحدّد من يرى ماذا ومن تُسند إليه الأعمال. وضعنا لك اقتراحات — عدّلها أو احذفها.",
    "setup.departmentAr": "اسم القسم {n} بالعربية",
    "setup.departmentEn": "اسم القسم {n} بالإنجليزية",
    "setup.departmentRemove": "أزِل القسم {n}",
    "setup.departmentAdd": "+ أضِف قسماً",
    "setup.suggest.content.ar": "المحتوى",
    "setup.suggest.content.en": "Content",
    "setup.suggest.management.ar": "الإدارة",
    "setup.suggest.management.en": "Management",
    "setup.suggest.moderation.ar": "المودريشن",
    "setup.suggest.moderation.en": "Moderation",
    "setup.suggest.media.ar": "الميديا باينج",
    "setup.suggest.media.en": "Media Buying",
    "setup.backupTitle": "مكان النسخة الاحتياطية",
    "setup.backupBody": "كل ليلة تُحفظ هنا نسخة كاملة من النظام. سنجرّب الوجهة الآن — نكتب ملف تجربة ونقرؤه ونحذفه — قبل المتابعة.",
    "setup.backupEndpoint": "عنوان التخزين",
    "setup.backupBucket": "اسم الحاوية",
    "setup.backupAccessKey": "مفتاح الدخول",
    "setup.backupSecretKey": "المفتاح السري",
    "setup.backupTest": "جرّب الوجهة",
    "setup.backupTesting": "جارٍ التجربة…",
    "setup.backupMustTest": "يجب تجربتها أولاً ليعمل زرّ «أنهِ الإعداد».",
    "setup.next": "التالي",
    "setup.finish": "أنهِ الإعداد",
    "setup.doneTitle": "«{name}» جاهز",
    "setup.doneOwner": "أُنشئ حساب المالك بكل الصلاحيات.",
    "setup.doneDepartments": "{n, plural, one {أُنشئ قسم واحد} two {أُنشئ قسمان} few {أُنشئت # أقسام} many {أُنشئ # قسماً} other {أُنشئ # قسم}}.",
    "setup.doneBackup": "سيبدأ النسخ الاحتياطي الليلة.",
    "setup.doneNext": "الخطوة التالية: ادخل بحسابك، وأضِف عملاءك وفريقك.",
    "setup.signIn": "ادخل بحساب المالك",
    "setup.emailInvalid": "البريد غير صحيح.",
    "setup.departmentRequired": "يجب وجود قسم واحد على الأقل.",
    "stepUp.title": "أكّد هويتك",
    "stepUp.why": "هذه عملية مهمة، لذا يطلب النظام كلمة سرّك مرة أخرى. ليس عطلاً.",
    "stepUp.thenRetries": "بعد التأكيد، ستُنفَّذ العملية تلقائياً.",
    "stepUp.thenPressAgain": "بعد التأكيد، اضغط الزرّ مرة أخرى.",
    "stepUp.password": "كلمة سرّك",
    "stepUp.confirm": "أكّد",
    "home.title": "الرئيسية",
    "home.subtitle": "ما ينتظرك الآن.",
    "home.allClear": "لا يوجد ما ينتظرك",
    "home.allClearBody": "أنجزت كل المطلوب منك. وأي جديد سيظهر هنا أولاً.",
    "home.open": "افتح",
    "home.greetingMorning": "صباح الخير يا {name}",
    "home.greetingEvening": "مساء الخير يا {name}",
    "home.waitingLead": "بانتظارك {n, plural, one {عنصر واحد} two {عنصران} few {# عناصر} many {# عنصراً} other {# عنصر}} — ابدأ بالأقدم.",
    "home.waitingTally": "بانتظارك",
    "home.otherActions": "{n} أخرى في «المطلوب منك» ←",
    "home.openAll": "افتح الـ{n} كلها",
    "home.andMore": "و {n} أخرى بالانتظار",
    "home.dueChange": "{from} ← {to}",
    "home.clearIn": "ولا يوجد ما ينتظر في:",
    "home.activity": "ما حدث اليوم",
    "home.live": "مباشر",
    "home.activityNone": "لم يحدث شيء اليوم بعد",
    "home.activityNoneBody": "فور أن يعمل أحد على عميل من عملائك سيظهر هنا، وكل سطر يفتح مكانه.",
    "home.system": "النظام",
    "home.myOverdue": "أعمال تجاوزت موعدها",
    "home.myOverdueBody": "{n, plural, one {عنصر واحد مُسند إليك تجاوز موعده} two {عنصران مُسندان إليك تجاوزا موعدهما} few {# عناصر مُسندة إليك تجاوزت مواعيدها} many {# عنصراً مُسنداً إليك تجاوز موعده} other {# عنصر مُسند إليك تجاوز موعده}}.",
    "home.myOverdueClear": "لا يوجد لديك ما تجاوز موعده.",
    "home.myOpenWork": "أعمال مفتوحة لديك",
    "home.myOpenWorkBody": "{n, plural, one {عمل واحد مُسند إليك لم يكتمل بعد} two {عملان مُسندان إليك لم يكتملا بعد} few {# أعمال مُسندة إليك لم تكتمل بعد} many {# عملاً مُسنداً إليك لم يكتمل بعد} other {# عمل مُسند إليك لم يكتمل بعد}}",
    "home.myOpenWorkClear": "لا يوجد لديك عمل مفتوح.",
    "home.awaitingReview": "بانتظار مراجعتك",
    "home.awaitingReviewBody": "{n, plural, one {مهمة واحدة سُلِّمت وتنتظر} two {مهمتان سُلِّمتا وتنتظران} few {# مهام سُلِّمت وتنتظر} many {# مهمة سُلِّمت وتنتظر} other {# مهمة سُلِّمت وتنتظر}} مراجعة داخلية.",
    "home.awaitingReviewClear": "لا توجد مهمة بانتظار المراجعة.",
    "actions.kind.planTaskReview": "مهمة سُلِّمت وتنتظر مراجعتك",
    "home.revisionExceptions": "استثناءات بانتظار قرارك",
    "home.revisionExceptionsBody": "{n, plural, one {طلب استثناء مراجعة واحد لم يبتّ فيه} two {طلبا استثناء مراجعة لم يبتّ فيهما} few {# طلبات استثناء مراجعة لم يبتّ فيها} many {# طلب استثناء مراجعة لم يبتّ فيه} other {# طلب استثناء مراجعة لم يبتّ فيه}} أحد.",
    "home.revisionExceptionsClear": "لا يوجد استثناء بالانتظار.",
    "home.dueChanges": "طلبات تغيير مواعيد",
    "home.dueChangesBody": "{n, plural, one {طلب تغيير موعد واحد} two {طلبا تغيير موعد} few {# طلبات تغيير موعد} many {# طلب تغيير موعد} other {# طلب تغيير موعد}} بانتظار قرارك.",
    "home.dueChangesClear": "لا يوجد طلب تغيير موعد بالانتظار.",
    "home.accessRequests": "طلبات صلاحيات",
    "home.accessRequestsBody": "{n, plural, one {طلب صلاحية واحد} two {طلبا صلاحية} few {# طلبات صلاحية} many {# طلب صلاحية} other {# طلب صلاحية}} بانتظار ردّك.",
    "home.accessRequestsClear": "لا يوجد طلب صلاحية بالانتظار.",
    "home.storageAlerts": "عملاء قاربت مساحتهم على النفاد",
    "home.storageAlertsBody": "{n, plural, one {عميل واحد تجاوز} two {عميلان تجاوزا} few {# عملاء تجاوزوا} many {# عميلاً تجاوز} other {# عميل تجاوز}} حدّ التنبيه.",
    "home.storageAlertsClear": "لا يوجد عميل قارب حدّ المساحة.",
    "settings.intro": "كل رقم وسياسة في النظام هنا — ويسري التغيير عندما تضغط «احفظ» في القسم الخاص به.",
    "settings.noneTitle": "لا توجد إعدادات",
    "settings.noneBody": "لا يعلن النظام أي إعدادات — هذا غير طبيعي، تواصل مع الدعم.",
    "settings.groupIdentity": "هويّة النظام",
    "settings.groupWork": "العمل والتذكيرات",
    "settings.groupPlans": "الخطط والمراجعات",
    "settings.groupStorage": "المساحة والحدود",
    "settings.groupSecurity": "الأمان",
    "settings.groupReports": "التقارير",
    "settings.groupRetention": "الاحتفاظ والنسخ",
    "settings.isDefault": "القيمة الافتراضية — لم تتغيّر",
    "settings.changedBy": "غيّرها {name} — {when}",
    "settings.noEffectYet": "لا تأثير له بعد",
    "settings.valueRequired": "يجب أن تكتب قيمة.",
    "settings.valueInvalid": "هذه القيمة غير مقبولة لهذا الإعداد.",
    "setup.settingInvalid": "هذه القيمة غير مقبولة لهذا الإعداد.",
    "notify.access.created.title": "طلب صلاحية جديد",
    "notify.access.created.body": "طلب موظف صلاحية — افتح الطلب لتبتّ فيه.",
    "notify.access.resolved.title": "صدر قرار في طلبك",
    "notify.access.resolved.body": "صدر قرار في طلب الصلاحية الخاص بك — افتحه لترى القرار.",
    "notify.org.headChanged.title": "تغيّرت رئاسة القسم",
    "notify.org.headChanged.body": "عُيّن رئيس جديد للقسم — وتغيّرت الصلاحيات معه.",
    "notify.org.delegationGranted.title": "فُوّضت إليك سلطة رئيس قسم",
    "notify.org.delegationGranted.body": "أصبحت تحمل سلطة رئيس القسم لمدة محدّدة — افتح القسم لترى المدة.",
    "notify.org.delegationRevoked.title": "سُحب التفويض",
    "notify.org.delegationRevoked.body": "سُحب التفويض الذي كان لديك على القسم.",
    "notify.identity.userCreated.title": "أُنشئ لك حساب",
    "notify.identity.userCreated.body": "أُنشئ لك حساب على النظام — غيّر كلمة السرّ فور دخولك.",
    "notify.identity.userDeactivated.title": "انتقلت إليك أعمال",
    "notify.identity.userDeactivated.body": "أُوقف موظف في قسمك، وأصبحت أعماله المفتوحة عليك — وزّعها.",
    "notify.identity.userReactivated.title": "عاد حسابك",
    "notify.identity.userReactivated.body": "أُعيد تفعيل حسابك — يمكنك الدخول كالمعتاد.",
    "notify.identity.passwordReset.title": "أُعيد تعيين كلمة سرّك",
    "notify.identity.passwordReset.body": "أعاد أحد المسؤولين تعيين كلمة سرّك. إن لم تطلب ذلك، تواصل مع الإدارة فوراً.",
    "notify.reports.submitted.title": "تقرير بانتظار مراجعتك",
    "notify.reports.submitted.body": "رُفع «{title}» وينتظر مراجعتك.",
    "notify.reports.reviewed.title": "تمّت مراجعة تقريرك",
    "notify.reports.reviewed.body": "«{title}»: {outcome}",
    "notify.reports.published.title": "وصلك تقرير جديد",
    "notify.reports.published.body": "أصبح «{title}» متاحاً — {outcome}",
    "notify.reports.exceptionRequested.title": "طلب استثناء تقرير",
    "notify.reports.exceptionRequested.body": "طلب أحدهم تقريراً ثانياً هذا الشهر: {reason}",
    "notify.reports.exceptionDecided.title": "صدر قرار في طلب الاستثناء",
    "notify.reports.exceptionDecided.body": "{decision}",
    "notify.moderation.published.title": "نُشر المنشور",
    "notify.moderation.published.body": "نُشر {title} على {platform}.",
    "notify.moderation.unpublished.title": "سُحبت علامة النشر",
    "notify.moderation.unpublished.body": "كان {title} معلَّماً بأنه نُشر، وسُحبت العلامة: {reason}",
    "notify.moderation.takedownRequested.title": "طلب إزالة محتوى منشور",
    "notify.moderation.takedownRequested.body": "طلب العميل إزالة {title} من {platform} — يحتاج إلى من يزيله يدوياً.",
    "notify.moderation.takedownResolved.title": "أُغلق طلب الإزالة",
    "notify.moderation.takedownResolved.body": "{title}: {resolution}",
    "notify.identity.sessionsRevoked.title": "أُغلقت جلساتك",
    "notify.identity.sessionsRevoked.body": "أُغلقت كل جلساتك — ستحتاج إلى تسجيل الدخول من جديد.",
    "errors.reportMonthTaken": "يوجد بالفعل تقرير لهذا العميل عن الشهر نفسه.",
    "errors.reportSelfReview": "هذا تقريرك أنت — لا أحد يراجع ما كتبه بنفسه.",
    "errors.reportLocked": "هذا التقرير ليس في حالة تسمح بالتعديل ({state}).",
    "errors.reportNotInReview": "هذا التقرير ليس بانتظار مراجعتك ({state}).",
    "errors.reportVersionPending": "توجد بالفعل نسخة جديدة بانتظار المراجعة.",
    "errors.reportExceptionAlreadyOpen": "يوجد طلب استثناء مفتوح لهذا الشهر.",
    "errors.reportExceptionDecided": "صدر قرار في هذا الطلب من قبل.",
    "errors.publicationAlreadyPublished": "هذا المنشور معلَّم بأنه نُشر بالفعل.",
    "errors.publicationNotPublished": "هذا المنشور لم يُنشر بعد، فلا توجد علامة لتُسحب.",
    "errors.publicationCancelled": "أُلغي هذا الصف — غالباً لأن العنصر عُدّل بعد اعتماده.",
    "errors.takedownAlreadyOpen": "يوجد بالفعل طلب إزالة مفتوح على هذا المنشور.",
    "errors.takedownAlreadyResolved": "أُغلق هذا الطلب من قبل.",
    "errors.destructiveInProduction": "هذا الأمر يحذف بيانات، وهذا التثبيت إنتاجي — فرُفض قبل أن يلمس أي صف.",
    "errors.envNotConfigured": "النظام غير مضبوط في بيئة التشغيل: {names}. أُوقف التشغيل عمداً — لن يعمل ناقصاً.",
    "errors.mailNotConfigured": "البريد غير مفعّل في هذا النظام. تواصل مع المسؤول.",
    "errors.mailSendFailed": "لم نتمكن من إرسال الرسالة الآن. حاول مرة أخرى، وإن تكرّر الفشل أعطِ المسؤول هذا الرمز.",
    "errors.dependencyUnavailable": "خدمة يعتمد عليها النظام لا تعمل الآن. حاول بعد قليل.",
    "errors.requestAborted": "أُلغي الطلب قبل اكتماله. إن بقيت الشاشة فارغة، حدّثها.",
    // ---------- التقارير ----------
    "chat.title": "المحادثات",
    "chat.channel.GENERAL": "الفريق كلّه",
    "chat.channel.CLIENT_INTERNAL": "داخليّ",
    "chat.channel.CLIENT_PORTAL": "مع العميل",
    "chat.channel.DIRECT": "محادثة",
    "chat.channel.GROUP": "مجموعة",
    "chat.newGroup": "مجموعة جديدة",
    "chat.newDirect": "راسِل زميلاً",
    "chat.groupName": "اسم المجموعة",
    "chat.groupMembers": "من فيها",
    "chat.groupCreated": "أُنشئت المجموعة.",
    "chat.groupNameRequired": "اكتب اسم المجموعة.",
    "chat.groupMembersRequired": "اختر شخصاً واحداً على الأقل غيرك.",
    "chat.directStarted": "فُتحت المحادثة.",
    "chat.compose": "اكتب رسالة",
    "chat.send": "أرسِل",
    "chat.sent": "أُرسلت.",
    "chat.edited": "عُدّلت",
    "chat.editedSaved": "حُفظ التعديل.",
    "chat.deletedByAuthor": "رسالة محذوفة",
    "chat.deletedByModerator": "رسالة حذفها الإشراف",
    "chat.deleteMessage": "احذف الرسالة",
    "chat.messageDeleted": "حُذفت الرسالة — ويبقى سطرها.",
    "chat.bodyRequired": "اكتب شيئاً أولاً.",
    "chat.addMember": "أضِف شخصاً",
    "chat.memberAdded": "أُضيف إلى المجموعة.",
    "chat.leave": "غادِر المجموعة",
    "chat.left": "غادرت المجموعة.",
    "chat.foldedNote": "مطويّة — أول رسالة ستفتحها من جديد",
    "chat.noMessagesYet": "لم يكتب أحد هنا بعد",
    "chat.sentFile": "أرسل ملفاً",
    "chat.lastLine": "{who}: {said}",
    "chat.you": "أنت",
    "chat.foldWarning": "ستُطوى هذه القناة غداً إن لم يكتب فيها أحد",
    "chat.unread": "جديد",
    "chat.presence.online": "متّصل",
    "chat.presence.away": "بعيد",
    "chat.presence.offline": "غير متّصل",
    "chat.noneTitle": "لا توجد قنوات",
    "chat.noneBody": "عندما تبدأ محادثة أو تُنشأ مجموعة، ستجدها هنا.",
    "chat.searchChannels": "ابحث عن عميل أو زميل…",
    "chat.section.general": "الكل",
    "chat.section.clients": "العملاء",
    "chat.section.groups": "المجموعات",
    "chat.section.direct": "رسائل مباشرة",
    "chat.pickChannel": "اختر قناة من القائمة لتقرأ رسائلها.",
    "chat.portalBand": "العميل يرى كل رسالة هنا — الحديث الداخلي مكانه قناة العميل الداخلية.",
    "chat.membersCount": "{count} في القناة",
    "chat.members": "أعضاء القناة",
    "chat.channelMore": "المزيد على القناة",
    "chat.messageMore": "المزيد على الرسالة",
    "chat.reply": "ردّ",
    "chat.replyingTo": "تردّ على {name}:",
    "chat.cancelReply": "ألغِ الرد",
    "chat.quoteDeleted": "رسالة محذوفة",
    "chat.addReaction": "أضِف تفاعلاً",
    "chat.reactionMine": "{emoji} {count} — منهم أنت، اضغط لإزالته",
    "chat.reactionOthers": "{emoji} {count} — اضغط لإضافته",
    "chat.emoji": "إيموجي",
    "chat.mention": "أشِر إلى زميل أو قسم",
    "emoji.search": "ابحث عن إيموجي",
    "emoji.searchHint": "ابحث بالعربية أو الإنجليزية… «قلب»، «ضحك»",
    "emoji.groups": "أقسام الإيموجي",
    "emoji.recent": "الأكثر استخداماً",
    "emoji.loading": "جارٍ تحميل الإيموجي…",
    "emoji.loadFailed": "لم تُحمَّل مكتبة الإيموجي — حاول مرة أخرى.",
    "emoji.noMatch": "لا يوجد إيموجي بهذا الاسم.",
    "emoji.group.smileys": "وجوه ومشاعر",
    "emoji.group.people": "أشخاص وأيدٍ",
    "emoji.group.animals": "حيوانات وطبيعة",
    "emoji.group.food": "طعام وشراب",
    "emoji.group.travel": "سفر وأماكن",
    "emoji.group.activities": "أنشطة",
    "emoji.group.objects": "أشياء",
    "emoji.group.symbols": "رموز",
    "emoji.group.flags": "أعلام",
    "time.today": "اليوم",
    "time.yesterday": "أمس",
    "time.tomorrow": "غداً",
    "time.dayWithDate": "{word} · {date}",
    "time.durationPair": "{a} و{b}",
    "time.minute.one": "دقيقة",
    "time.minute.two": "دقيقتان",
    "time.minute.few": "{n} دقائق",
    "time.minute.other": "{n} دقيقة",
    "time.hour.one": "ساعة",
    "time.hour.two": "ساعتان",
    "time.hour.few": "{n} ساعات",
    "time.hour.other": "{n} ساعة",
    "time.day.one": "يوم",
    "time.day.two": "يومان",
    "time.day.few": "{n} أيام",
    "time.day.other": "{n} يوم",
    "time.zone.cairo": "القاهرة",
    "time.zone.riyadh": "الرياض",
    "time.zone.dubai": "دبي",
    "time.zone.kuwait": "الكويت",
    "time.zone.doha": "الدوحة",
    "time.zone.amman": "عمّان",
    "time.zone.london": "لندن",
    "time.zone.utc": "توقيت جرينتش",
    "common.blankValue": "…",
    "platforms.instagram": "إنستغرام",
    "platforms.facebook": "فيسبوك",
    "platforms.tiktok": "تيك توك",
    "platforms.linkedin": "لينكدإن",
    "platforms.x": "إكس",
    "platforms.youtube": "يوتيوب",
    "platforms.snapchat": "سناب شات",
    "platforms.threads": "ثريدز",
    "colors.teal": "تركواز",
    "colors.blue": "أزرق",
    "colors.purple": "بنفسجي",
    "colors.brown": "بنّي",
    "colors.raspberry": "توتي",
    "colors.green": "أخضر",
    "colors.custom": "لون مخصّص",
    "platform.notifications.cadenceSetting": "يُرسَل تلقائياً حسب إعداد «{setting}»",
    "settings.noEffectYetHint": "يُحفظ، لكن النظام لا يستخدمه بعد — سيعمل في تحديث قادم.",
    "cards.checklistProgress": "{done} من {total}",
    "plans.platforms": "المنصّات",
    "plans.showToClient": "مخفي عن العميل — أظهِره",
    "plans.hideFromClient": "العميل يراه — أخفِه",
    "boards.pickClient": "العميل",
    "boards.pickClientFirst": "اختر العميل أولاً",
    "home.allActivity": "كل النشاط",
    "chat.emptyChannelTitle": "القناة فارغة",
    "chat.emptyChannelBody": "لا توجد رسائل هنا بعد — اكتب أول رسالة.",
    "errors.chatChannelNotReachable": "هذه القناة غير متاحة لك.",
    "errors.chatMessageNotYours": "هذه ليست رسالتك — الحذف للإشراف.",
    "errors.chatMessageGone": "حُذفت هذه الرسالة بالفعل.",
    "errors.chatReactionInvalid": "يجب أن يكون التفاعل إيموجي واحداً — اختره من المكتبة.",
    "errors.chatReplyTargetInvalid": "الرسالة التي تردّ عليها حُذفت أو ليست في هذه القناة.",
    "errors.chatDirectWithSelf": "لا يمكنك فتح محادثة مع نفسك.",
    "errors.chatPortalChannelOnly": "هذا الردّ لقناة العميل فقط.",
    "errors.meetingOwnProposal": "لا يمكنك قبول اقتراحك أنت — الطرف الآخر هو من يقبله.",
    "errors.meetingLinkRequired": "يجب إرفاق رابط الاجتماع (زوم أو مِيت) مع الموعد.",
    "errors.meetingStateInvalid": "حالة الاجتماع «{state}» — هذا الإجراء لا ينطبق عليها.",
    "errors.meetingNotOver": "لم يحن موعده بعد — انتظر حتى ينتهي.",
    "notify.chat.mentioned.title": "أشار إليك أحدهم في المحادثات",
    "notify.chat.mentioned.body": "«{channel}» — {excerpt}",
    "notify.chat.portalMessage.title": "كتب العميل في المحادثات",
    "notify.chat.portalMessage.body": "«{client}» — {excerpt}",
    "notify.chat.portalReply.title": "ردّ من الوكالة",
    "notify.chat.portalReply.body": "{excerpt}",
    "notify.chat.foldSoon.title": "قناة على وشك أن تُطوى",
    "notify.chat.foldSoon.body": "«{channel}» صامتة منذ {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يوماً} other {# يوم}} — أول رسالة تعيدها.",
    "notify.meeting.requested.title": "طلب اجتماع جديد",
    "notify.meeting.requested.body": "طلب «{client}» اجتماعاً — {when}. ردّ عليه بالقبول أو باقتراح موعد آخر.",
    "notify.meeting.proposed.title": "موعد مقترَح لاجتماعك",
    "notify.meeting.proposed.body": "اقترح فريقك {when} — وافِق أو اقترح موعداً آخر. سيظهر الرابط بعد التأكيد.",
    "notify.meeting.confirmed.title": "تمّ تأكيد الاجتماع",
    "notify.meeting.confirmed.body": "الموعد {when} — والرابط داخل الاجتماع.",
    "notify.meeting.rejected.title": "رُفض الموعد",
    "notify.meeting.rejected.body": "السبب: {reason}. اقترح موعداً آخر إن كنت لا تزال بحاجة إلى الاجتماع.",
    "notify.meeting.cancelled.title": "أُلغي الاجتماع",
    "notify.meeting.cancelled.body": "كان {when} — السبب: {reason}.",
    "notify.meeting.reminderHour.title": "اجتماعك بعد ساعة",
    "notify.meeting.reminderHour.body": "{when} — جهّز ما تحتاجه قبله.",
    "notify.meeting.reminderSoon.title": "اجتماعك بعد ٥ دقائق",
    "notify.meeting.reminderSoon.body": "{when} — افتح الرابط وانضمّ.",
    "portal.chat.subtitle": "محادثتك مع الوكالة — في مكان واحد.",
    "portal.chat.compose": "اكتب للوكالة",
    "portal.chat.sent": "وصلت رسالتك.",
    "portal.chat.noneTitle": "لا توجد رسائل بعد",
    "portal.chat.noneBody": "اكتب أول رسالة وسيردّ عليك فريقك هنا.",
    "analytics.title": "التحليلات",
    "analytics.subtitle": "أرقام حقيقية — اضغط أيّ رقم لتفتح القائمة التي حُسب منها.",
    "analytics.level.company": "الشركة",
    "analytics.level.department": "قسمي",
    "analytics.level.client": "عميل",
    "analytics.level.mine": "أرقامي",
    "analytics.period.this-month": "هذا الشهر",
    "analytics.period.last-month": "الشهر الماضي",
    "analytics.period.this-quarter": "هذا الربع",
    "analytics.period.year": "السنة",
    "analytics.metric.planItemsDue": "مستحق في المدة",
    "analytics.metric.planItemsCompleted": "اكتمل في المدة",
    "analytics.metric.completionRate": "نسبة الالتزام",
    "analytics.metric.planItemsOverdue": "تأخّر",
    "analytics.metric.planItemsOpen": "لا يزال مفتوحاً",
    "analytics.metric.publishedOnTime": "نُشر في موعده",
    "analytics.metric.publishedLate": "نُشر متأخّراً",
    "analytics.metric.avgResponseMinutes": "متوسط الردّ على الإشارة",
    "analytics.noChange": "دون تغيير",
    "analytics.drillTitle": "القائمة التي حُسب منها",
    "analytics.drillEmptyTitle": "لا توجد صفوف",
    "analytics.drillEmptyBody": "الرقم صفر في هذه المدة — لا يوجد ما يُعرض.",
    "analytics.noneTitle": "لا توجد أرقام في هذه المدة",
    "analytics.noneBody": "لا يوجد عمل مستحقّ في المدة التي اخترتها. غيّر المدة أو انتظر أول خطة.",
    "analytics.ranking": "الترتيب",
    "analytics.rankingMe": "هذا أنت",
    "analytics.clients": "صحة العملاء",
    "analytics.workload": "الأحمال",
    "analytics.goals": "الأهداف",
    "analytics.goalNew": "+ هدف جديد",
    "analytics.goalMetric": "المقياس",
    "analytics.goalTarget": "الرقم المطلوب",
    "analytics.goalDirection": "الاتجاه",
    "analytics.goalDirection.at-least": "لا يقلّ عن",
    "analytics.goalDirection.at-most": "لا يزيد على",
    "analytics.goalPeriod": "الشهر",
    "analytics.goalState.achieved": "تحقّق",
    "analytics.goalState.breached": "لم يتحقّق",
    "analytics.goalState.pending": "قيد القياس",
    "analytics.goalSaved": "حُفظ الهدف.",
    "analytics.goalDeleted": "حُذف الهدف.",
    "analytics.goalTargetRequired": "اكتب الرقم المطلوب.",
    "analytics.goalsNoneTitle": "لا توجد أهداف",
    "analytics.goalsNoneBody": "حدّد هدفاً لمقياس وشهر، وسنبلغك فور تحقّقه أو عدم تحقّقه.",
    "analytics.export": "صدِّر CSV",
    "analytics.exported": "تمّ تجهيز الملف.",
    "analytics.exportPick": "افتح رقماً أولاً — يُصدَّر الملف من القائمة التي حُسب منها.",
    "analytics.levelLabel": "أرقام مَن",
    "analytics.periodLabel": "المدة",
    "analytics.drillGo": "القائمة التي حُسب منها ←",
    "analytics.noPrevious": "لا توجد مدة سابقة للمقارنة",
    "analytics.deltaUp": "▲ {n} عن المدة السابقة",
    "analytics.deltaDown": "▼ {n} عن المدة السابقة",
    "analytics.deltaUpPoints": "▲ {n, plural, one {نقطة واحدة} two {نقطتان} few {# نقاط} many {# نقطة} other {# نقطة}} عن المدة السابقة",
    "analytics.deltaDownPoints": "▼ {n, plural, one {نقطة واحدة} two {نقطتان} few {# نقاط} many {# نقطة} other {# نقطة}} عن المدة السابقة",
    "analytics.goalProgress": "{value} من {target}",
    "analytics.goalDelete": "احذف الهدف",
    "analytics.goalDeleteMark": "×",
    "errors.analyticsLevelNotAllowed": "«{metric}» لا معنى له على مستوى {level} — اختر مستوى آخر.",
    "errors.analyticsGoalDuplicate": "يوجد بالفعل هدف لهذا المقياس في هذا الشهر.",
    "notify.analytics.goalAchieved.title": "تحقّق هدف",
    "notify.analytics.goalAchieved.body": "«{metric}» وصل إلى {value} — والمطلوب كان {target}.",
    "notify.analytics.goalBreached.title": "لم يتحقّق هدف",
    "notify.analytics.goalBreached.body": "«{metric}» توقّف عند {value} — والمطلوب كان {target}.",
    "reports.title": "التقارير",
    "reports.subtitle": "تقرير لكل عميل كل شهر — يمرّ برئيس القسم ثم الإدارة قبل أن يصل إلى العميل.",
    "reports.new": "+ تقرير جديد",
    "reports.titleField": "عنوان التقرير",
    "reports.titleRequired": "اكتب عنوان التقرير.",
    "reports.bodyField": "المتن",
    "reports.bodyRequired": "اكتب متن التقرير — سطر واحد ليس تقريراً.",
    "reports.month": "الشهر",
    "reports.submit": "أرسِله للمراجعة",
    "reports.submitted": "أُرسل التقرير للمراجعة.",
    "reports.saved": "حُفظ.",
    "reports.newVersion": "أنشأنا نسخة جديدة — سيرى العميل النسخة القديمة حتى تتمّ الموافقة على هذه.",
    "reports.return": "أعِده إلى كاتبه",
    "reports.returnReasonRequired": "اكتب السبب — من سيقرؤه يحتاج أن يعرف ما يجب إصلاحه.",
    "reports.approvedHead": "وافق عليه رئيس القسم.",
    "reports.approvedAdmin": "نُشر للعميل.",
    "reports.returned": "أُعيد إلى كاتبه.",
    "reports.state.DRAFT": "مسودّة",
    "reports.state.SUBMITTED": "عند الرئيس",
    "reports.state.HEAD_APPROVED": "عند الإدارة",
    "reports.state.ADMIN_APPROVED": "معتمَد",
    "reports.state.PUBLISHED": "وصل إلى العميل",
    "reports.state.RETURNED": "أُعيد إلى كاتبه",
    "reports.state.EXPIRED": "استُبدل بنسخة أحدث",
    "reports.exception": "اطلب استثناء",
    "reports.exceptionRow": "طلب استثناء",
    "reports.exceptionReason": "لماذا تحتاج تقريراً ثانياً هذا الشهر؟",
    "reports.exceptionReasonRequired": "اكتب السبب.",
    "reports.exceptionAsked": "وصل الطلب إلى الإدارة.",
    "reports.decisionRequired": "اكتب قرارك وسببه.",
    "reports.grantException": "اسمح بتقرير ثانٍ",
    "reports.refuseException": "ارفض الطلب",
    "reports.exceptionDecided": "سُجّل القرار.",
    "reports.pickClient": "اختر العميل",
    "reports.save": "احفظ",
    "reports.edit": "عدِّل",
    "reports.decision": "قرارك وسببه",
    "reports.exceptionState.OPEN": "بانتظار قرار الإدارة",
    "reports.exceptionState.GRANTED": "سُمح بتقرير ثانٍ",
    "reports.exceptionState.REFUSED": "رُفض",
    "errors.reportEditAlreadyAsked": "يوجد بالفعل طلب تعديل مفتوح على هذا التقرير.",
    "reports.editAsked": "وصل طلبك إلى كاتب التقرير.",
    "reports.editReasonRequired": "اكتب ما يحتاج إلى تصحيح.",
    "reports.requestEdit": "اطلب تعديلاً",
    "reports.editReason": "ما الذي يحتاج إلى تصحيح؟",
    "reports.clientAsked": "طلب العميل تعديلاً",
    "notify.reports.editRequested.title": "طلب عميل تعديلاً على تقرير",
    "notify.reports.editRequested.body": "«{title}» — {reason}",
    "reports.noneTitle": "لا توجد تقارير",
    "reports.noneBody": "حين يكتب أحدٌ تقريراً لعميل، سيظهر هنا مع مرحلة مراجعته.",
    "reports.waiting": "بانتظار قرارك",
    "reports.writeTitle": "تقرير جديد",
    "reports.exceptionWants": "يريد تقريراً ثانياً هذا الشهر: «{reason}»",
    "reports.decisionHint": "مثلاً: موافق — للحملة ميزانية منفصلة",
    "reports.yourReview": "بانتظار مراجعتك",
    "reports.writtenBy": "كتبه {name}",
    "reports.headApprovedBy": "وافق عليه {name} (رئيس القسم)",
    "reports.fileCount": "{count, plural, one {ملف واحد} two {ملفان} few {# ملفات} many {# ملفاً} other {# ملف}}",
    "reports.openReview": "افتحه وراجِعه",
    "reports.editReport": "عدِّل التقرير",
    "reports.allClients": "كل العملاء",
    "reports.clientColumn": "العميل",
    "reports.thisMonth": "{month} · هذا الشهر",
    "reports.inReview": "في المراجعة",
    "reports.missing": "ناقص",
    "reports.missingWrite": "ناقص — اكتبه",
    "reports.matrixHint": "اضغط أيّ خانة لتفتح التقرير. الخانة المنقّطة = لم يكتبه أحد بعد — تفتح «تقرير جديد» لهذا العميل وهذا الشهر.",
    "reports.lastEdited": "آخر تعديل {when}",
    "reports.versionTag": "نسخة جديدة",
    "reports.older": "شهور أقدم",
    "reports.newer": "شهور أحدث",
    "reports.menu": "المزيد — عدِّل · اطلب استثناءً",
    "reports.path": "مسار التقرير",
    "reports.step.written": "كُتب",
    "reports.step.head": "رئيس القسم",
    "reports.step.admin": "الإدارة",
    "reports.step.client": "العميل",
    "reports.stepApproved": "{name} وافق",
    "reports.yourCall": "بانتظار قرارك",
    "reports.stepWaiting": "بانتظار",
    "reports.headSkipped": "انتقل إلى الإدارة مباشرةً",
    "reports.addFile": "+ أضِف ملفاً",
    "reports.openFile": "افتح",
    "reports.removeFile": "احذف {name}",
    "reports.history": "ما حدث",
    "reports.historyNone": "لم يُسجَّل شيء على هذا التقرير بعد.",
    "reports.did.created": "{name} كتبه",
    "reports.did.submitted": "{name} أرسله للمراجعة",
    "reports.did.headApproved": "{name} وافق عليه — انتقل إلى الإدارة",
    "reports.did.adminApproved": "{name} وافق — وصل إلى العميل",
    "reports.did.returned": "{name} أعاده: «{reason}»",
    "reports.did.headReviewed": "{name} راجعه (رئيس القسم)",
    "reports.did.adminReviewed": "{name} راجعه (الإدارة)",
    "reports.did.clientAsked": "{name} طلب تعديلاً من بوابة العميل",
    "reports.returnHint": "إن كنت ستُعيده: ما الذي يحتاج إلى إصلاح؟",
    "reports.returnPlaceholder": "اكتب السبب — من سيقرؤه يحتاج أن يعرف ما عليه فعله",
    "reports.approvePublish": "وافِق — يصل إلى العميل",
    "reports.approveHead": "وافِق — ينتقل إلى الإدارة",
    // ---------- الوساطة والنشر ----------
    "moderation.title": "طابور النشر",
    "moderation.subtitle": "ما وافق عليه العميل وينتظر النشر.",
    "moderation.waiting": "بانتظار",
    "moderation.published": "نُشر",
    "moderation.schedule": "حدّد موعداً",
    "moderation.scheduleAt": "موعد النشر",
    "moderation.saveSchedule": "احفظ الموعد",
    "moderation.markPublished": "علِّم أنه نُشر",
    "moderation.proofUrl": "رابط المنشور على المنصّة",
    "moderation.proofRequired": "أضِف رابط المنشور — بدونه يبقى الوسم بلا سند.",
    "moderation.publishedAt": "نُشر: {at}",
    "moderation.publishedBy": "وسمه: {name}",
    "moderation.withdraw": "اسحب الوسم",
    "moderation.withdrawReason": "سبب السحب",
    "moderation.withdrawReasonRequired": "اكتب سبب السحب — سيُقرأ بعد شهور.",
    "moderation.withdrawn": "سُحب الوسم، وعاد العنصر إلى الجدولة.",
    "moderation.marked": "عُلِّم أنه نُشر.",
    "moderation.schedulePicked": "حُدّد الموعد.",
    "moderation.takedownReasonRequired": "اكتب سبب الطلب.",
    "moderation.takedownOpen": "طلب إزالة مفتوح",
    "moderation.takedownAsked": "سُجّل الطلب — يجب أن يحذف أحدٌ المنشور يدوياً.",
    "moderation.resolution": "ماذا فعلت بالضبط؟",
    "moderation.resolutionRequired": "اكتب ما فعلته — النظام لا يحذف المنشورات تلقائياً.",
    "moderation.removedIt": "حذفته فعلاً من المنصّة",
    "moderation.refusedIt": "لن يُحذف، والسبب مكتوب هنا",
    "moderation.resolved": "أُغلق الطلب.",
    "moderation.noneTitle": "الطابور فارغ",
    "moderation.noneBody": "لا يوجد ما ينتظر النشر الآن. حين يوافق عميل على عنصر، سيظهر هنا.",
    "moderation.takedowns": "طلبات إزالة",
    "moderation.client": "العميل",
    "moderation.platform": "المنصّة",
    "moderation.late": "فات موعده",
    "moderation.lateHint": "كان يجب أن يُنشر — انشره أو حدّد موعداً جديداً",
    "moderation.lateBy": "فات موعده منذ {hours, plural, one {ساعة واحدة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}}",
    "moderation.undated": "بلا موعد",
    "moderation.previewOf": "معاينة {title}",
    "moderation.noCaption": "لم يُكتب نصّ منشور لهذا العنصر.",
    "moderation.copyCaption": "انسخ نصّ المنشور",
    "moderation.captionCopied": "نُسخ نصّ المنشور.",
    "moderation.captionCopyFailed": "منع المتصفّح النسخ — ظلّل النصّ وانسخه يدوياً.",
    "moderation.files": "الملفات ({count})",
    "moderation.openPost": "افتح المنشور",
    "moderation.confirmPublished": "تأكيد — نُشر",
    "moderation.more": "المزيد على المنشور",
    "common.all": "الكل",
    // ---------- الدخول ----------
    "auth.signIn": "تسجيل الدخول",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة السر",
    "auth.forgot": "نسيت كلمة السر؟",
    "auth.forgotTitle": "نسيت كلمة السر",
    "auth.forgotSub": "اكتب بريدك، وسنرسل لك رابطاً تختار به كلمة سرّ جديدة.",
    "auth.forgotSend": "أرسِل لي الرابط",
    "auth.forgotSent": "إن كان هذا البريد مسجّلاً لدينا، فسيصله رابط خلال دقائق. افحص صندوق الوارد (والرسائل المزعجة أيضاً).",
    "auth.forgotOff": "استعادة كلمة السرّ غير مفعّلة في هذا النظام — تواصل مع المسؤول لتفعيلها.",
    "auth.backToSignIn": "العودة إلى تسجيل الدخول",
    "invite.subReset": "اختر كلمة سرّ جديدة. فور حفظها، سيُسجَّل الخروج من كل جهاز حسابك مفتوح عليه.",
    // ---------- نصوص البريد الصادر ----------
    "errors.emailTaken": "هذا البريد مستخدم في حساب آخر ({email}).",
    "errors.inviteAccountStopped": "هذا الحساب موقوف، فلا يمكن إرسال دعوة إليه.",
    "people.emailSave": "احفظ البريد",
    "people.emailChanged": "تغيّر البريد، وأصبح الدخول به من الآن.",
    "people.emailHint": "البريد الذي يدخل به الموظف وتصله عليه الرسائل. وتغييره يوقف أي رابط دعوة لم يُستعمل.",
    "people.sendInvite": "أرسل الدعوة بالبريد",
    "people.inviteMailed": "أُرسلت الدعوة بالبريد.",
    "people.sendInvites": "إرسال الدعوات",
    "people.invites.title": "إرسال الدعوات",
    "people.invites.intro": "لم يدخل هؤلاء النظام بعد. راجع البريد الحقيقي لكل موظف، ثم أرسل إليه رابط اختيار كلمة السر. يعمل الرابط مرة واحدة خلال 7 أيام.",
    "people.invites.none": "دخل كل الموظفين النظام بالفعل.",
    "people.invites.sendAll": "أرسل إلى من لم تصله ({count})",
    "people.invites.confirmAll": "ستُرسل رسالة إلى {count} من الموظفين. هل تتابع؟",
    "people.invites.saveFirst": "احفظ البريد أولاً",
    "people.invites.send": "أرسل",
    "people.invites.resend": "أعد الإرسال",
    "people.invites.sending": "جارٍ الإرسال…",
    "people.invites.mailedAt": "أُرسلت {when}",
    "mail.invite.subject": "حسابك جاهز على مِنوال",
    "mail.invite.body": "مرحباً {name}،\n\nأصبح حسابك جاهزاً على مِنوال. ستدخل بهذا البريد: {email}\n\nافتح هذا الرابط واختر كلمة السر الخاصة بك:\n{link}\n\nيعمل الرابط مرة واحدة خلال {days} أيام. وإذا انتهت مدته، اطلب رابطاً جديداً من إدارة النظام.",
    "mail.reset.subject": "رابط استعادة كلمة السر",
    "mail.reset.body": "مرحباً {name}،\n\nوصلنا طلب لتغيير كلمة سرّك. افتح هذا الرابط واختر كلمة جديدة:\n{link}\n\nيعمل هذا الرابط مرّة واحدة وينتهي بعد {minutes, plural, one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}}.\nوإن لم تكن أنت من طلب ذلك، فتجاهل الرسالة — كلمة سرّك لم تتغيّر.",
    "auth.signOut": "تسجيل الخروج",
    // ---------- ملفي: البيانات والأمان والجلسات ----------
    "profile.about": "بياناتي",
    "profile.photo": "صورتي",
    "profile.photoHint": "تظهر صورتك لزملائك في كل مكان يظهر فيه اسمك. الحدّ ٢ ميجابايت.",
    "profile.photoChoose": "اختر صورة",
    "profile.photoReplace": "غيّر الصورة",
    "profile.photoRemove": "أزِل الصورة",
    "profile.photoSaved": "حُفظت الصورة.",
    "profile.photoRemoved": "أُزيلت الصورة.",
    "profile.photoNone": "لا توجد صورة لإزالتها.",
    "profile.photoRequired": "اختر صورة أولاً.",
    "profile.photoUploading": "جارٍ رفع الصورة…",
    "profile.name": "الاسم",
    "profile.language": "لغة النظام",
    "profile.theme": "المظهر",
    "profile.themeSystem": "مثل الجهاز",
    "profile.themeLight": "نهاري",
    "profile.themeDark": "ليلي",
    "profile.saved": "حُفظت بياناتك.",
    "profile.valueInvalid": "هذه القيمة ليست مما يقبله النظام لهذا الحقل.",
    "profile.languageNote": "تُحفظ اللغة والمظهر في حسابك، فترافقك على أي جهاز. ويُغيَّر البريد من شاشة الموظفين.",
    "profile.security": "كلمة السرّ",
    "profile.passwordChange": "غيّر كلمة السر",
    // ---------- الجلسات ----------
    "sessions.title": "الأجهزة التي حسابك مفتوح عليها",
    "sessions.thisDevice": "هذا الجهاز",
    "sessions.titleCount": "الأجهزة التي حسابك مفتوح عليها · {n}",
    "sessions.fromIp": "من عنوان {ip}",
    "sessions.end": "أغلِقه",
    "sessions.ended": "أُغلق الجهاز. إن كان شخصاً آخر، فقد خرج الآن.",
    "sessions.endOthers": "أغلِق الأجهزة الأخرى",
    "sessions.endOthersConfirm": "سيُسجَّل الخروج من كل الأجهزة الأخرى، وستحتاج إلى تسجيل الدخول عليها من جديد. يبقى هذا الجهاز مفتوحاً.",
    "sessions.endedOthers": "{n, plural, one {أُغلق جهاز واحد آخر} two {أُغلق جهازان آخران} few {أُغلقت # أجهزة أخرى} many {أُغلق # جهازاً آخر} other {أُغلق # جهاز آخر}}. لا يزال هذا الجهاز مفتوحاً.",
    "sessions.endedNone": "لا توجد أجهزة أخرى مفتوحة.",
    "sessions.onlyThis": "حسابك مفتوح على هذا الجهاز فقط.",
    // ---------- اسم الجهاز ----------
    "device.on": "{browser} على {os}",
    "device.browserOnly": "{browser}",
    "device.osOnly": "{os}",
    "device.unknown": "جهاز غير معروف",
    "device.browser.chrome": "كروم",
    "device.browser.safari": "سفاري",
    "device.browser.firefox": "فايرفوكس",
    "device.browser.edge": "إيدج",
    "device.browser.opera": "أوبرا",
    "device.browser.samsung": "متصفّح سامسونج",
    "device.os.windows": "ويندوز",
    "device.os.macos": "ماك",
    "device.os.ios": "آيفون",
    "device.os.ipad": "آيباد",
    "device.os.android": "أندرويد",
    "device.os.linux": "لينكس",
    // ---------- القوقعة والتنقّل ----------
    "nav.home": "الرئيسية",
    "nav.actions": "المطلوب منك",
    "nav.actionsBadge": "بانتظار قرارك",
    "nav.chat": "المحادثات",
    "nav.notifications": "الإشعارات",
    "nav.health": "صحة النظام",
    "nav.reports": "التقارير",
    "nav.analytics": "التحليلات",
    "nav.moderation": "طابور النشر",
    "nav.storage": "التخزين",
    "nav.audit": "سجلّ النشاط",
    "nav.changelog": "سجلّ التغييرات",
    "nav.notificationsAdmin": "صياغة الإشعارات",
    "nav.settings": "الإعدادات",
    "nav.errorCatalog": "دليل رموز الأخطاء",
    "nav.profile": "ملفي",
    "nav.more": "المزيد",
    "nav.group.general": "عام",
    "nav.group.system": "النظام",
    "nav.group.me": "حسابي",
    "shell.skipToContent": "انتقل إلى المحتوى",
    "shell.mainNavigation": "التنقّل الرئيسي",
    "shell.themeDark": "الوضع الليلي",
    "shell.themeLight": "الوضع النهاري",
    "shell.switchLanguage": "تغيير اللغة",
    "shell.localeArabic": "العربية",
    "shell.localeEnglish": "English",
    "shell.notificationsRegion": "رسائل النظام",
    "shell.offline": "لا يوجد اتصال بالإنترنت الآن. فور عودته، سنكمل من هنا.",
    "shell.installWhy": "ثبّته على الجهاز ليفتح أسرع وتصلك تنبيهاته.",
    "shell.install": "ثبّت النظام على الجهاز",
    "shell.noScreenYet": "لم تُطلق هذه الشاشة بعد",
    "shell.noScreenYetBody": "تُطلق كل شاشة مع الوحدة الخاصة بها. القائمة أعلاه مبنية من صلاحياتك الفعلية، فستتّسع تلقائياً مع كل وحدة.",
    "shell.quickNavigation": "شريط التنقّل",
    "auth.signedOut": "خرجت من النظام.",
    "auth.signInTitle": "الدخول إلى {systemName}",
    "auth.signInSubtitle": "ادخل ببريدك الإلكتروني وكلمة السرّ.",
    "auth.signingIn": "جارٍ تسجيل دخولك…",
    "auth.emailRequired": "اكتب البريد الإلكتروني.",
    "auth.passwordRequired": "اكتب كلمة السرّ.",
    "errors.catalogTitle": "دليل رموز الأخطاء",
    "errors.catalogSubtitle": "حين يرسل لك أحدٌ رمز خطأ — ابحث عنه هنا لتعرف سببه وعلاجه.",
    "errors.catalogSearch": "ابحث بالرمز أو بالنصّ",
    "errors.catalogIncident": "تُفتح له حادثة",
    "errors.catalogEmpty": "لا يوجد رمز يطابق البحث.",
    "errors.catalogCauseLead": "السبب:",
    "errors.catalogRemedyLead": "العلاج:",
    "errors.signInRejected": "البريد أو كلمة السرّ غير صحيحة. راجعهما وحاول مرة أخرى.",
    "tasks.blockReasonRequired": "اكتب سبب التعطيل — من سيستلمها يحتاج أن يعرف ما الذي تنتظره.",
    "tasks.state.open": "مفتوحة",
    "tasks.state.inProgress": "جارية",
    "tasks.state.blocked": "معطّلة",
    "tasks.state.done": "منجَزة",
    "tasks.priority.normal": "عادية",
    "tasks.priority.high": "مهمة",
    "tasks.priority.critical": "حرجة",
    "tasks.created": "سُجّلت المهمة ووصلت إلى المكلّفين.",
    "tasks.assigned": "تغيّر المكلّفون.",
    "tasks.moved": "تغيّرت حالة المهمة.",
    "tasks.titleRequired": "اكتب عنوان المهمة.",
    "tasks.dueRequired": "يجب أن يكون للمهمة موعد تسليم.",
    "tasks.assigneesRequired": "اختر شخصاً واحداً على الأقل لتُسنَد إليه المهمة.",
    "tasks.departmentRequired": "اختر القسم الذي ستُرسَل إليه المهمة.",
    "tasks.stateRequired": "اختر الحالة التي ستنتقل إليها.",
    "tasks.versionRequired": "وصل الطلب بلا رقم النسخة — حدِّث الشاشة.",
    "notify.tasks.assigned.title": "مهمة جديدة لك",
    "notify.tasks.assigned.body": "أُسندت إليك مهمة مباشرة — افتحها لترى الموعد والتفاصيل.",
    "notify.tasks.updated.title": "عُدّلت مهمة",
    "notify.tasks.updated.body": "عدّل أحدهم مهمة أنت طرف فيها.",
    "notify.tasks.stateChanged.title": "تغيّرت حالة مهمة",
    "notify.tasks.stateChanged.body": "تحرّكت مهمة أنت طرف فيها — افتحها لترى إلى أين.",
    "notify.tasks.commented.title": "تعليق جديد",
    "notify.tasks.commented.body": "يوجد تعليق جديد على مهمة أنت طرف فيها.",
    "notify.platform.settingChanged.title": "تغيّر إعداد",
    "notify.platform.settingChanged.body": "غيّر أحدهم إعداداً في النظام.",
    "notify.roles.matrixReplaced.title": "تغيّرت صلاحيات دور",
    "notify.roles.matrixReplaced.body": "عُدّلت مصفوفة صلاحيات دور — افتح الدور لترى الجديد.",
    "notify.identity.roleAssigned.title": "تغيّر دورك",
    "notify.identity.roleAssigned.body": "أُسند إليك دور جديد — وتغيّرت صلاحياتك معه.",
    "notify.identity.overrideCreated.title": "صلاحية استثنائية",
    "notify.identity.overrideCreated.body": "سُجّل لك استثناء بمدّة محدّدة — افتح ملفك لترى تفاصيله.",
    "notify.identity.overrideRemoved.title": "أُزيل استثناء",
    "notify.identity.overrideRemoved.body": "أُزيل استثناء كان مسجّلاً لك — عادت صلاحياتك إلى دورك.",
    "notifications.title": "الإشعارات",
    "notifications.empty": "لا توجد إشعارات الآن.",
    "notifications.emptyBody": "حين يحدث شيء يخصّك، ستجده هنا.",
    "notifications.archive": "أرشفة",
    "notifications.archiveOf": "أرشفة «{title}»",
    "notifications.archiveRead": "أرشفة كل المقروء",
    "notifications.archivedTab": "الأرشيف",
    "notifications.archivedRead": "أُرشف كل المقروء.",
    "notifications.markRead": "علّم كمقروء",
    "notifications.markAllRead": "علّم الكل كمقروء",
    "notifications.show": "اعرض",
    "notifications.all": "الكل",
    "notifications.unreadOnly": "غير المقروء · {count}",
    "notifications.noneUnread": "قرأت كل الجديد — لا شيء بانتظارك.",
    "notifications.markReadOf": "علّم «{title}» كمقروء",
    "notifications.noDestination": "لا يعرف هذا الإشعار أين يُفتح. أرسِل الرمز إلى مسؤول النظام.",
    "notifications.allRead": "عُلّمت كلها كمقروءة.",
    "common.timezoneIs": "بتوقيت",
    "common.noMatch": "لا توجد نتيجة مطابقة.",
    "tasks.title": "المهام المباشرة",
    "tasks.subtitle": "عمل داخلي غير مرتبط بعميل — حسب الموعد.",
    "tasks.new": "مهمة جديدة",
    "tasks.filter": "تصفية",
    "tasks.filterAll": "الكل",
    "tasks.filterMine": "مهامي",
    "tasks.filterOverdue": "متأخر",
    "tasks.emptyTitle": "لا توجد مهام بعد",
    "tasks.emptyBody": "المهمة المباشرة عمل داخلي ترسله لأحد في فريقك — مثل «راجع العقد».",
    "tasks.emptyFilteredTitle": "لا شيء ضمن هذه التصفية",
    "tasks.emptyFilteredBody": "أزِل التصفية لترى الباقي.",
    "tasks.detail": "تفاصيل المهمة",
    "tasks.due": "موعد التسليم",
    "tasks.assignees": "المكلّفون",
    "tasks.priority": "الأولوية",
    "tasks.department": "القسم",
    "tasks.titleField": "عنوان المهمة",
    "tasks.block": "عطّلها",
    "tasks.blockReason": "سبب التعطيل",
    "tasks.blockedBecause": "معطّلة بسبب:",
    "tasks.thread": "التعليقات",
    "tasks.noComments": "لا توجد تعليقات بعد.",
    "tasks.writeComment": "اكتب تعليقاً…",
    "tasks.send": "أرسِل",
    "tasks.saving": "جارٍ الحفظ…",
    "tasks.edit": "عدّل المهمة",
    "tasks.changeAssignees": "غيّر المكلّفين",
    "tasks.descriptionField": "الوصف",
    "tasks.reloadToSeeLatest": "حدِّث الصفحة لترى تعديل زميلك قبل أن تكتب فوقه.",
    "tasks.newButton": "+ مهمة جديدة",
    "tasks.filterOverdueCount": "متأخر · {count}",
    "tasks.allDepartments": "كل الأقسام",
    "tasks.group.overdue": "متأخر",
    "tasks.group.today": "اليوم",
    "tasks.group.week": "هذا الأسبوع",
    "tasks.group.later": "لاحقاً",
    "tasks.group.done": "منجَزة",
    "tasks.markDone": "علِّم «{title}» كمنجَزة",
    "tasks.reopen": "أعِد فتح «{title}»",
    "tasks.filesCount": "{count, plural, one {ملف مرفق واحد} two {ملفان مرفقان} few {# ملفات مرفقة} many {# ملفاً مرفقاً} other {# ملف مرفق}}",
    "tasks.madeBy": "أنشأها {name}",
    "tasks.options": "خيارات المهمة",
    "tasks.done": "منجَزة",
    "tasks.lateSince": "متأخرة · {since}",
    "tasks.editShort": "عدّل",
    "tasks.files": "الملفات",
    "tasks.filesTitle": "الملفات · {count}",
    "tasks.addFile": "+ أضِف ملفاً",
    "tasks.openFile": "افتح",
    "nav.tasks": "المهام",
    "notifications.unreadCount": "غير مقروءة",
    "attachments.sizeRequired": "يجب أن يكون للملف حجم صحيح.",
    "attachments.filenameRequired": "يجب أن يكون للملف اسم.",
    "attachments.queuedForScan": "رُفع الملف ويجري فحصه الآن — سيكون جاهزاً بعد ثوانٍ.",
    "attachments.removed": "حُذف المرفق.",
    "attachments.add": "أضِف ملفاً",
    "attachments.scanning": "جارٍ الفحص…",
    "attachments.rejected": "رُفض في الفحص",
    "attachments.none": "لا توجد مرفقات.",
    "attachments.uploading": "جارٍ الرفع…",
    "attachments.limit": "الحدّ الأقصى {limitMb} ميجابايت للملف.",
    "units.bytes": "{n} بايت",
    "units.kilobytes": "{n} كيلوبايت",
    "units.megabytes": "{n} ميجابايت",
    "attachments.download": "تنزيل",
    "attachments.remove": "احذف المرفق",
    "attachments.removeConfirm": "هل تحذف «{filename}»؟",
    "attachments.pendingHint": "يجري فحص المرفق — يمكن تنزيله فور انتهاء الفحص.",
    "errors.cardTransitionNotAllowed": "لا تنتقل البطاقة من «{from}» إلى «{to}» مباشرةً — انقلها إلى حالة وسيطة أولاً.",
    "errors.reopenWindowClosed": "مهلة إعادة الفتح {graceMinutes, plural, one {دقيقة واحدة} two {دقيقتان} few {# دقائق} many {# دقيقة} other {# دقيقة}} من وقت الإنجاز، وقد انتهت. صار ذلك من صلاحية رئيس القسم.",
    "errors.orderKeyExhausted": "بلغ الترتيب في هذا الموضع حدّه ({maxLength, plural, one {حرف واحد} two {حرفان} few {# أحرف} many {# حرفاً} other {# حرف}}). أعِد توزيع ترتيب العمود مرة واحدة وتُحلّ المشكلة.",
    "errors.clientArchived": "«{client}» مؤرشف — أعماله للقراءة فقط ولا تُعدَّل. استعِده أولاً إن كان العمل مستمراً.",
    "errors.clientNotArchived": "«{client}» لا يزال نشطاً، وهذه العملية للعملاء المؤرشفين فقط.",
    "errors.clientDeleteNotReady": "لا يمكن حذف «{client}» قبل: {missing}",
    "errors.clientDeleteIncomplete": "توقّف حذف «{client}» عند خطوة «{step}»: {detail} — عالِج السبب واستأنف، وسيُكمل من حيث توقّف.",
    "errors.clientExportNotReady": "هذه النسخة ليست جاهزة للتنزيل بعد — إمّا أنها قيد التجهيز وإمّا أنها فشلت. حالتها مكتوبة بجانبها.",
    "plans.slidesNeedMultiSlideType": "هذا النوع ليس متعدّد الشرائح — غيّر النوع أو ارفع معاينة واحدة.",
    "plans.periodRequired": "اختر نوع الفترة — أسبوعية أو شهرية أو ربع سنوية.",
    "plans.dateRequired": "التاريخ ناقص.",
    "plans.invalidDate": "هذا التاريخ غير صحيح.",
    "plans.typeRequired": "اختر نوع العمل.",
    "plans.platformsInvalid": "يجب أن تكون المنصّات قائمة أسماء.",
    "plans.stateRequired": "اختر الحالة التي ستنقله إليها.",
    "plans.decisionRequired": "اختر قراراً — موافقة أو رفض.",
    "plans.reviewDecisionRequired": "اختر قرار المراجعة — اعتماد أو إرجاع.",
    "plans.mediaKindRequired": "اختر نوع الوسيط.",
    "plans.typeKeyRequired": "اكتب مفتاحاً للنوع — حروف إنجليزية صغيرة وشرطات.",
    "plans.versionRequired": "النسخة ناقصة — حدِّث الشاشة وحاول مرة أخرى.",
    "plans.nameRequired": "اكتب اسماً للخطة.",
    "plans.titleRequired": "اكتب عنواناً للعنصر.",
    "plans.reviewReasonRequired": "اكتب سبب الإرجاع — صاحب العمل يحتاج أن يعرف ما يجب إصلاحه.",
    "plans.onBehalfReasonRequired": "اكتب سبب تسجيلك للقرار بالنيابة عن العميل.",
    "plans.rejectionCommentRequired": "الرفض يحتاج إلى تعليق يوضّح المطلوب.",
    "plans.cancelReasonRequired": "اكتب سبب الإلغاء.",
    "plans.caption": "نصّ المنشور",
    "plans.title": "الخطط",
    "plans.subtitle": "خطط العميل وعناصرها ودورة اعتمادها",
    "plans.pickClient": "اختر العميل",
    "plans.itemsTitle": "عناصر الخطة",
    "plans.item": "العنصر",
    "plans.type": "النوع",
    "plans.state": "الحالة",
    "plans.deliverBy": "التسليم",
    "plans.publishAt": "النشر",
    "plans.assignees": "المسنَد إليه",
    "plans.clientSees": "يراه العميل",
    "plans.parked": "متوقّف على استثناء",
    "plans.counts.published": "منشور",
    "plans.counts.approved": "معتمَد",
    "plans.counts.working": "قيد التنفيذ",
    "plans.counts.cancelled": "ملغي",
    "plans.emptyPlan": "الخطة فارغة — افتحها وأضِف أول عنصر.",
    "plans.openPlan": "افتح الخطة",
    "plans.backToPlans": "‹ الخطط",
    "plans.itemCount": "{n, plural, one {عنصر واحد} two {عنصران} few {# عناصر} many {# عنصراً} other {# عنصر}}",
    "plans.noPlansTitle": "لا توجد خطط لهذا العميل بعد",
    "plans.noPlansBody": "هنا تظهر خطط الشهر بعناصرها ودورة اعتمادها. ابدأ بأول خطة.",
    "plans.noItemsTitle": "الخطة لا تزال فارغة",
    "plans.noItemsBody": "أضِف عناصر الخطة — كل عنصر بنوعه وموعد تسليمه ومن سينفّذه.",
    "plans.clientCannotSee": "مخفي عن العميل",
    "plans.revisionsUsed": "مراجعات العميل:",
    "plans.exceptionPending": "العنصر متوقّف على استثناء مراجعة يحتاج إلى قرار من الإدارة",
    "plans.grantException": "امنح الاستثناء",
    "plans.denyException": "ارفض الاستثناء",
    "plans.gateOne": "البوابة الأولى — المراجعة الداخلية",
    "plans.gateTwo": "البوابة الثانية — قرار العميل",
    "plans.gateThree": "البوابة الثالثة — النشر",
    "plans.reviewReason": "سبب الإرجاع (مطلوب إن كنت ستُعيده)",
    "plans.agencyPublishes": "الوكالة هي التي تنشر — ستُنشئ الموافقة صفوف نشر.",
    "plans.clientPublishes": "العميل ينشر بنفسه — ستُنهي الموافقة العنصر مباشرةً.",
    "plans.onBehalfReason": "سبب تسجيلك للقرار بالنيابة",
    "plans.decisionComment": "تعليق العميل",
    "plans.recordApproval": "سجّل موافقة العميل",
    "plans.recordRejection": "سجّل رفض العميل",
    "plans.proofInModeration": "يُسجَّل إثبات النشر في طابور النشر.",
    "plans.media": "الوسائط",
    "plans.addMedia": "أضِف وسيطاً",
    "plans.mediaKind": "نوع الوسيط",
    "plans.decisions": "قرارات العميل",
    "plans.approved": "وافق",
    "plans.rejected": "رفض",
    "plans.onBehalf": "بالنيابة",
    "plans.reason": "السبب",
    "plans.withdraw": "اسحب الاعتماد",
    "plans.cancel": "ألغِ العنصر",
    "plans.history": "التاريخ",
    "plans.created": "أُنشئت الخطة.",
    "plans.saved": "حُفظ التعديل.",
    "plans.deleted": "حُذفت الخطة.",
    "plans.items.created": "أُنشئ العنصر وأُسند.",
    "plans.items.saved": "حُفظ التعديل.",
    "plans.items.moved": "نُقل العنصر.",
    "plans.items.cancelled": "أُلغي العنصر.",
    "plans.items.decided": "سُجّل قرار العميل.",
    "plans.items.visibilitySaved": "تغيّرت رؤية العميل.",
    "plans.items.withdrawn": "سُحب الاعتماد وعاد العنصر إلى التنفيذ.",
    "plans.exceptions.resolved": "حُسم الاستثناء.",
    "plans.media.added": "أُضيف الوسيط.",
    "plans.media.detached": "فُصل الوسيط.",
    "plans.comments.added": "أُرسل التعليق.",
    "plans.comments.saved": "عُدّل التعليق.",
    "plans.comments.deleted": "حُذف التعليق.",
    "plans.itemTypes.saved": "حُفظ نوع العمل.",
    "plans.newPlan": "خطة جديدة",
    "plans.editPlan": "تعديل الخطة",
    "plans.planName": "اسم الخطة",
    "plans.startsOn": "تبدأ يوم",
    "plans.endsOn": "تنتهي يوم",
    "plans.deletePlan": "حذف الخطة",
    "plans.deleteConfirm": "ستُحذف الخطة «{name}». يُسمح بحذف الخطة الفارغة فقط — وإن كانت فيها عناصر فسيُرفض الحذف مع ذكر السبب.",
    "plans.newItem": "عنصر جديد",
    "plans.itemTitle": "عنوان العنصر",
    "plans.itemTypes": "أنواع العمل",
    "plans.newItemType": "نوع جديد",
    "plans.editItemType": "تعديل النوع",
    "plans.itemTypeKey": "المفتاح — إنجليزي صغير، مثل reel",
    "plans.itemTypeNeedsCover": "يحتاج إلى صورة غلاف",
    "plans.itemTypeMultiSlide": "متعدّد الشرائح (كاروسيل)",
    "plans.detachMedia": "افصِله",
    "plans.detachConfirm": "هل تفصل هذا الملف عن العنصر؟ إن كان معاينة، فلن يراه العميل بعد الآن.",
    "clients.publishingSaved": "حُفظت مسؤولية النشر.",
    "plans.missing.preview": "معاينة العميل",
    "plans.task.state.not_started": "لم تبدأ بعد",
    "plans.task.state.in_progress": "قيد التنفيذ",
    "plans.task.state.delivered": "سُلِّمت",
    "plans.task.state.approved": "اعتُمدت",
    "plans.task.state.returned": "أُعيدت",
    "plans.task.dueAfterItem": "موعد المهمة بعد تسليم العنصر — يجب أن يكون قبله أو في الموعد نفسه.",
    "plans.deliverBeforeTasks": "توجد مهمة موعدها بعد التسليم الجديد — غيّر موعدها أولاً.",
    "plans.decide.partsRequired": "اختر الجزء الذي سيعود للتعديل — الريل أو الغلاف أو كلاهما.",
    "plans.task.nameRequired": "اسم المهمة مطلوب.",
    "plans.task.coverRequired": "هذا النوع يحتاج إلى غلاف — أضِف مهمة للغلاف.",
    "plans.priorityRequired": "اختر أولوية العنصر.",
    "plans.task.ownerRequired": "اختر صاحب المهمة.",
    "plans.referencesInvalid": "يجب أن تكون المراجع روابط.",
    "plans.items.prioritySaved": "حُفظت الأولوية.",
    "plans.priority": "الأولوية",
    "plans.tasks": "المهام",
    "plans.tov": "النص على التصميم (TOV)",
    "plans.tov.hint": "النص الذي سيُكتب على الفيديو أو التصميم نفسه — يعمل منه المصمّم ومحرّر الفيديو.",
    "plans.cancelHint": "يبقى العنصر الملغي شاهداً في الخطة — اكتب السبب.",
    "plans.withdrawHint": "سحب الاعتماد يُعيد كل مهمة إلى صاحبها ويُلغي النشرات التي لم تُنشر بعد.",
    "plans.caption.revokes": "تعديله بعد موافقة العميل يُعيده إلى قراره من جديد.",
    "plans.compose.addTask": "+ مهمة",
    "plans.compose.contentLater": "يُضاف الموجز والمراجع ونصّ المنشور والـ TOV بعد إنشاء العنصر، من تبويب «المحتوى».",
    "plans.compose.removeTask": "أزِل مهمة «{name}»",
    "plans.compose.requiredHint": "الخانات المعلَّمة بـ * مطلوبة — بدونها لن يعرف المصمّم كيف يرتّب عمله.",
    "plans.compose.submit": "أضِف العنصر",
    "plans.compose.tasksTitle": "المهام — اقترحها النوع «{type}»",
    "plans.decide.partsLegend": "إن رُفض — أيّ جزء يعود؟",
    "plans.deliverByHint": "آخر موعد ليكون العنصر جاهزاً للمراجعة",
    "plans.publishAtHint": "يحدّد الأولوية في جدول المصمّم",
    "plans.exceptionNote": "ملاحظة على القرار (اختياري)",
    "plans.gate.internal": "داخلي",
    "plans.gate.client": "العميل",
    "plans.gate.publish": "النشر",
    "plans.gates": "البوابات",
    "plans.itemMenu": "خيارات العنصر",
    "plans.media.none": "لا يوجد موجز ولا مواد بعد.",
    "plans.part.clientApproved": "وافق عليه العميل",
    "plans.publish.afterApproval": "تدخل طابور النشر فور موافقة العميل على كل الأجزاء.",
    "plans.references": "المراجع",
    "plans.references.add": "+ رابط",
    "plans.references.none": "لا توجد مراجع بعد.",
    "plans.references.remove": "أزِل الرابط {link}",
    "plans.tab.work": "العمل",
    "plans.tab.content": "المحتوى",
    "plans.tab.review": "المراجعة والعميل",
    "plans.tab.talk": "النقاش",
    "plans.tabs": "أقسام العنصر",
    "plans.talk.hint": "نقاش هذا العنصر فقط — بالإشارات @ والملفات. الملاحظات الداخلية لا تصل إلى العميل.",
    "plans.work.hint": "لكل مهمة صاحبها وموعدها — والتأخير يُحتسب على المهمة، لا على العنصر كله.",
    "plans.task.approve": "اعتمد",
    "plans.task.deliver": "سلّم المهمة",
    "plans.task.due": "موعدها",
    "plans.task.dueOn": "موعدها {date}",
    "plans.task.edit": "عدّل",
    "plans.task.final": "التسليم النهائي",
    "plans.task.finalLink": "رابط التسليم النهائي",
    "plans.task.isCover": "معاينتها هي غلاف العنصر",
    "plans.task.late": "متأخرة",
    "plans.task.name": "المهمة",
    "plans.task.notYet": "ليس بعد",
    "plans.task.owner": "مَن",
    "plans.task.pickOwner": "اختر صاحب المهمة",
    "plans.task.preview": "المعاينة للعميل",
    "plans.task.previewFirst": "ارفع المعاينة أولاً — لا تسليم بدونها.",
    "plans.task.previewLink": "أو رابط المعاينة",
    "plans.task.remove": "احذف",
    "plans.task.removeConfirm": "حذف مهمة «{name}»؟",
    "plans.task.replacePreview": "استبدل المعاينة",
    "plans.task.return": "أعِدها مع ذكر السبب",
    "plans.task.returnedBy": "أُعيدت من المراجعة:",
    "plans.task.returnedByClient": "أعادها العميل:",
    "plans.task.sendReturn": "أعِدها",
    "plans.task.start": "ابدأ",
    "plans.task.uploadPreview": "ارفع المعاينة",
    "plans.view": "طريقة العرض",
    "plans.view.pipeline": "المسار",
    "plans.view.table": "جدول",
    "plans.openItem": "افتح «{title}»",
    "plans.preview.none": "لا توجد معاينة بعد",
    "plans.lane.rule": "يمرّ كل عنصر بثلاث بوابات: مراجعة داخلية ← موافقة العميل ← النشر. اضغط العنصر لفتحه.",
    "plans.lane.working": "قيد التنفيذ",
    "plans.lane.workingHint": "مسودّة · مُسنَد · قيد التنفيذ · مُعاد للتعديل",
    "plans.lane.review": "مراجعة داخلية",
    "plans.lane.reviewHint": "بانتظار الاعتماد قبل إرساله إلى العميل",
    "plans.lane.client": "عند العميل",
    "plans.lane.clientHint": "اعتُمد داخلياً — بانتظار قرار العميل",
    "plans.lane.scheduled": "تمّت الموافقة والجدولة",
    "plans.lane.scheduledHint": "وافق العميل — في طابور النشر",
    "plans.lane.published": "نُشر",
    "plans.lane.publishedHint": "نُشر مع إثبات — رابط المنشور في لوحته",
    "plans.lane.cancelled": "{n} ملغاة — اعرضها",
    "plans.itemTypeTasks": "المهام التي يقترحها النوع",
    "plans.itemTypeTasksHint": "تظهر جاهزة عند إنشاء عنصر من هذا النوع — ويمكن تغييرها. النوع الذي يحتاج غلافاً يجب أن يقترح مهمة غلاف.",
    "plans.itemTypeTaskAr": "المهمة {n} بالعربية",
    "plans.itemTypeTaskEn": "المهمة {n} بالإنجليزية",
    "plans.itemTypeTaskRemove": "أزِل المهمة {n}",
    "priority.urgent": "عاجل",
    "priority.high": "مرتفع",
    "priority.normal": "عادي",
    "priority.low": "منخفض",
    "errors.planTaskMoveInvalid": "لا يمكن نقل المهمة بهذه الطريقة وهي «{from}» — ربما نقلها أحد قبلك.",
    "plans.state.draft": "مسودّة",
    "plans.state.assigned": "مُسنَد",
    "plans.state.in_progress": "قيد التنفيذ",
    "plans.state.internal_review": "مراجعة داخلية",
    "plans.state.internal_revision": "مُعاد للتعديل",
    "plans.state.approved_internally": "معتمَد داخلياً",
    "plans.state.client_approved": "وافق العميل",
    "plans.state.scheduled": "مجدول",
    "plans.state.published": "منشور",
    "plans.state.done": "مكتمل",
    "plans.state.cancelled": "ملغى",
    "plans.period.weekly": "أسبوعية",
    "plans.period.monthly": "شهرية",
    "plans.period.quarterly": "ربع سنوية",
    "plans.media.brief": "الموجز",
    "plans.media.material": "مواد مرجعية",
    "plans.media.deliverable": "التسليم",
    "plans.media.preview": "معاينة العميل",
    "plans.media.cover": "صورة الغلاف",
    "plans.media.slide": "شرائح الكاروسيل",
    "plans.publication.pending": "في الطابور",
    "plans.publication.scheduled": "مجدولة",
    "plans.publication.published": "نُشرت",
    "plans.publication.failed": "فشلت",
    "plans.publication.cancelled": "أُلغيت",
    "plans.assignee.notMember": "ليس في فريق العميل",
    "plans.assignee.notActive": "الحساب موقوف",
    "plans.assignee.departmentNotAssignable": "قسمه لا يُسنَد إليه عمل الخطط",
    "errors.planTransitionInvalid": "لا يمكن نقل العنصر من {from} إلى {to}.",
    "errors.planItemIncomplete": "المهمة ينقصها ما يلزم قبل التسليم.",
    "errors.planReviewSelf": "لا يمكنك مراجعة مهمة أنت صاحبها.",
    "errors.planItemNotDecidable": "العنصر ليس في حالة تقبل قرار العميل ({state}).",
    "errors.planPublishedEditRefused": "العنصر {state} — اسحب الاعتماد أولاً قبل تعديله.",
    "errors.planLastAssignee": "يجب أن تبقى في العنصر مهمة واحدة على الأقل.",
    "errors.planAssigneeNotEligible": "لا يمكن إسناد العنصر إلى «{user}» — {reason}.",
    "errors.planExceptionPending": "يوجد استثناء مراجعة معلّق على هذا العنصر.",
    "errors.planCancelInvalidState": "العنصر {state} — لا يمكن إلغاؤه.",
    "errors.planNameDuplicate": "توجد خطة بالاسم نفسه «{name}» وللفترة نفسها لهذا العميل.",
    "errors.planDateRangeInvalid": "يجب أن تكون نهاية الخطة بعد بدايتها.",
    "errors.planNotEditRequestable": "العنصر {state} — لا يوجد اعتماد لتطلب تعديله.",
    "errors.planAlreadyWithdrawn": "سُحب الاعتماد بالفعل وعاد العنصر إلى التنفيذ.",
    "errors.planMediaSourceInvalid": "اختر ملفاً أو رابطاً — واحداً منهما فقط.",
    "errors.confirmationNameMismatch": "اكتب الاسم حرفياً كما هو معروض: «{expected}» — بالعربية أو بالإنجليزية.",
    "errors.dueChangeAlreadyPending": "يوجد طلب تغيير موعد معلّق على هذه البطاقة من {requestedBy}. انتظر البتّ فيه أو اسحبه.",
    "errors.dueChangeAlreadyResolved": "{decidedBy} بتّ في هذا الطلب بالفعل. حدّث الشاشة لترى القرار.",
    "errors.boardLastColumn": "هذا آخر عمود في اللوحة — أضِف عموداً بديلاً أولاً، أو أرشِف اللوحة كلها.",
    "errors.columnDeleteNeedsTarget": "في العمود {cardCount, plural, one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}}. اختر العمود الذي ستُنقل إليه.",
    "errors.mentionNotRelevant": "«{department}» ليست له علاقة معلَنة بهذا العمل، والإشارة إلى القسم تصل إلى جميع أفراده.",
    "errors.uniqueValueTaken": "هذه القيمة مستخدمة بالفعل في «{entity}» ({constraint}) — غيّرها وحاول مرة أخرى.",
    "errors.databaseConstraint": "يوجد شيء آخر يعتمد على «{entity}» ({constraint}) — احذفه أولاً.",
    "clients.title": "العملاء",
    "clients.created": "أُضيف العميل.",
    "clients.updated": "حُفظت بيانات العميل.",
    "clients.archived": "أُرشف العميل — أصبح عمله للقراءة فقط.",
    "clients.restored": "عاد العميل نشطاً.",
    "clients.deleted": "حُذف العميل نهائياً.",
    "clients.exportStarted": "بدأ التصدير — سنبلغك فور انتهائه.",
    "clients.memberAdded": "أصبح {name} في فريق العميل — ويمكنه الآن رؤية عمله.",
    "clients.memberRemoved": "أُزيل {name} من فريق العميل.",
    "clients.accountManagerSet": "أصبح {name} مدير حساب العميل.",
    "clients.quotaSaved": "حُفظ حدّ المساحة.",
    "storage.orphans.title": "ملفات يتيمة — تحتاج إلى قرار",
    "storage.orphans.subtitle": "ملف موجود في التخزين وليس له صف في قاعدة البيانات (أو العكس). الفحص الذي يعمل كل ساعة يكتشفها.",
    "storage.orphans.hidden": "توجد صفوف خارج نطاقك، عددها:",
    "storage.orphans.storageOnly": "بايتات بلا صف",
    "storage.orphans.rowOnly": "صف بلا بايتات",
    "storage.orphans.noClient": "صاحبه غير معروف",
    "storage.orphans.emptyTitle": "التخزين وقاعدة البيانات متطابقان",
    "storage.orphans.emptyBody": "يظهر هنا أي ملف موجود في التخزين وليس له صف في قاعدة البيانات، أو العكس. تعمل المطابقة كل ساعة ولا تجد الآن أي فرق.",
    "clients.nameRequired": "اسم العميل مطلوب بالعربية والإنجليزية.",
    "clients.keyRequired": "رمز العميل مطلوب — حروف إنجليزية صغيرة وشرطات.",
    "clients.timezoneRequired": "توقيت العميل مطلوب — تُعرض شاشاته به.",
    "clients.accountManagerNotMember": "يجب أن يكون مدير الحساب من فريق العميل.",
    "clients.memberNotActive": "هذا الموظف موقوف — لا يُضاف الموقوف إلى فريق عميل.",
    "clients.lastAccountManager": "هذا مدير الحساب — عيّن غيره أولاً قبل إخراجه.",
    "clients.archiveConfirm": "أرشفة «{name}»؟ سيصبح عمله كله للقراءة فقط.",
    "clients.deleteImpact": "سيُحذف: {cards, plural, one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}} · {boards, plural, one {لوحة واحدة} two {لوحتان} few {# لوحات} many {# لوحة} other {# لوحة}} · {files, plural, one {ملف واحد} two {ملفان} few {# ملفات} many {# ملفاً} other {# ملف}} · {members, plural, one {عضو فريق واحد} two {عضوا فريق} few {# أعضاء فريق} many {# عضو فريق} other {# عضو فريق}}.",
    "clients.deleteMissingArchive": "أرشفته",
    "clients.deleteMissingExport": "تصدير مكتمل",
    "clients.storage": "المساحة",
    "clients.storageUsed": "المستهلك {used} من {quota} ({percent}%)",
    "clients.team": "الفريق",
    "clients.accountManager": "مدير الحساب",
    "clients.archivedBadge": "مؤرشف",
    "boards.title": "اللوحات",
    "boards.created": "أُنشئت اللوحة.",
    "boards.updated": "حُفظت اللوحة.",
    "boards.archived": "أُرشفت اللوحة.",
    "boards.restored": "استُعيدت اللوحة.",
    "boards.columnAdded": "أُضيف العمود.",
    "boards.columnUpdated": "حُفظ العمود.",
    "boards.columnRemoved": "أُزيل العمود.",
    "boards.reordered": "حُفظ الترتيب.",
    "boards.templateSaved": "حُفظ القالب.",
    "boards.templateRemoved": "حُذف القالب.",
    "boards.nameRequired": "اسم اللوحة مطلوب.",
    "boards.columnNameRequired": "اسم العمود مطلوب.",
    "boards.columnsRequired": "يجب أن يحتوي القالب على عمود واحد على الأقل.",
    "boards.columnNameAr": "اسم العمود (بالعربية)",
    "boards.columnNameEn": "اسم العمود (بالإنجليزية)",
    "boards.columnRemove": "احذف العمود",
    "boards.columnRemoveConfirm": "حذف هذا العمود؟ إنه فارغ، ويمكنك إضافة غيره لاحقاً.",
    "boards.columnMoveStart": "حرّكه إلى الأمام",
    "boards.columnMoveEnd": "حرّكه إلى الخلف",
    "boards.create": "لوحة جديدة",
    "boards.nameAr": "اسم اللوحة (بالعربية)",
    "boards.nameEn": "اسم اللوحة (بالإنجليزية)",
    "boards.templateNone": "بدون قالب",
    "boards.templateNoneHint": "ستبدأ بأعمدة افتراضية يمكنك تعديلها لاحقاً.",
    "boards.template": "القالب",
    "boards.noTemplate": "بلا قالب",
    "cards.title": "البطاقات",
    "cards.created": "أُنشئت البطاقة.",
    "cards.updated": "حُفظت البطاقة.",
    "cards.stateChanged": "تغيّرت حالة البطاقة.",
    "cards.archived": "أُرشفت البطاقة للجميع.",
    "cards.restored": "استُعيدت البطاقة — وعاد تكرارها معها.",
    "cards.hidden": "أُخفيت البطاقة عنك أنت فقط.",
    "cards.unhidden": "عادت البطاقة إلى قائمتك.",
    "cards.assigned": "حُفظ الإسناد.",
    "cards.commented": "نُشر التعليق.",
    "cards.commentEdited": "عُدّل التعليق — والنسخة السابقة محفوظة.",
    "cards.commentRemoved": "حُذف التعليق.",
    "cards.labelCreated": "أُنشئت التسمية.",
    "cards.labelUpdated": "حُفظت التسمية.",
    "cards.labelRemoved": "حُذفت التسمية من قائمة التسميات.",
    "cards.checklistSaved": "حُفظت البنود.",
    "cards.titleRequired": "عنوان البطاقة مطلوب.",
    "cards.dueRequired": "الموعد مطلوب — العقوبة الوحيدة على التأخير هي الترتيب، ولا تعمل بلا موعد.",
    "cards.assigneesRequired": "اختر شخصاً واحداً على الأقل للإسناد.",
    "cards.assigneeNotActive": "{name} موقوف ولا يمكن إضافته إلى الكارت.",
    "cards.blockReasonRequired": "اكتب سبب التوقّف — من سيستلمها يحتاج إلى معرفة ما الذي تنتظره.",
    "comments.mentionNotOnRecord": "لا يمكنك الإشارة إلى شخص لا علاقة له بهذا العمل.",
    "cards.checklistItemRequired": "اكتب البند.",
    "cards.labelNameRequired": "اسم التسمية مطلوب.",
    "cards.columnRequired": "اختر العمود.",
    "cards.state.open": "مفتوح",
    "cards.state.inProgress": "قيد التنفيذ",
    "cards.state.blocked": "متوقّف",
    "cards.state.done": "منجَز",
    "cards.state.reopened": "أُعيد فتحه",
    "cards.checklist": "البنود",
    "cards.labels": "التسميات",
    "cards.overdue": "متأخّر",
    "cards.archivedBadge": "مؤرشف",
    "cards.due.request": "اطلب تغيير الموعد",
    "cards.due.requested": "وصل الطلب إلى رئيس القسم ومدير حساب العميل — أوّل من يبتّ فيه يُغلقه.",
    "cards.due.approved": "تغيّر الموعد، وأُعيدت جدولة التذكيرات.",
    "cards.due.rejected": "رُفض الطلب.",
    "cards.due.changed": "تغيّر الموعد.",
    "cards.due.reasonRequired": "اكتب سبب طلب التغيير.",
    "cards.due.newDateRequired": "اختر الموعد الجديد.",
    "cards.due.pending": "طلب تغيير موعد معلّق",
    "cards.due.requestedBy": "{name} طلب {date}",
    "cards.recurrence": "التكرار",
    "cards.recurrence.none": "لا يتكرّر",
    "cards.recurrence.daily": "كل يوم",
    "cards.recurrence.weekly": "كل أسبوع",
    "cards.recurrence.monthly": "كل شهر",
    "cards.recurrence.nextRun": "التالي: {date}",
    "cards.recurrence.monthlyClamped": "الشهر الذي ليس فيه يوم {day} تُنشأ فيه البطاقة في آخر يوم منه.",
    "cards.recurrence.stopped": "توقّف التكرار مع الأرشفة — والاستعادة ستعيده.",
    "cards.reminder.due": "«{title}» موعده {when}.",
    "cards.escalation.late": "«{title}» متأخّر {days, plural, one {يوماً واحداً} two {يومين} few {# أيام} many {# يوماً} other {# يوم}} ولم يحرّكه المسنَد إليه.",
    "myWork.title": "أعمالي",
    "myWork.cards": "بطاقات العملاء",
    "myWork.tasks": "المهام المباشرة",
    "notify.clients.created": "عميل جديد",
    "notify.clients.createdBody": "{actor} أضاف «{subject}».",
    "notify.clients.memberAddedTitle": "انضممت إلى فريق عميل",
    "notify.clients.memberAddedBody": "{actor} أضافك إلى فريق «{subject}» — أصبح عمل هذا العميل ظاهراً لك.",
    "notify.clients.memberRemovedTitle": "خرجت من فريق عميل",
    "notify.clients.memberRemovedBody": "{actor} أخرجك من فريق «{subject}».",
    "notify.clients.managerTitle": "مدير حساب العميل",
    "notify.clients.managerBody": "{actor} عيّنك مدير حساب «{subject}» — أصبحت تبتّ في طلبات تغيير المواعيد.",
    "notify.clients.archivedTitle": "أُرشف عميل",
    "notify.clients.archivedBody": "{actor} أرشف «{subject}» — أصبح عمله للقراءة فقط، ولا يمكن تعديله.",
    "notify.clients.restoredTitle": "عاد عميل نشطاً",
    "notify.clients.restoredBody": "{actor} استعاد «{subject}» — العمل عليه مفتوح مرة أخرى، وعاد التكرار.",
    "notify.clients.exportTitle": "تصدير بيانات عميل",
    "notify.clients.exportBody": "{actor} طلب تصدير «{subject}».",
    "notify.clients.deletedTitle": "حُذف عميل نهائياً",
    "notify.clients.deletedBody": "{actor} حذف «{subject}» نهائياً، بعد أرشفته وتصديره.",
    "notify.clients.quotaTitle": "تغيّر حدّ التخزين",
    "notify.clients.quotaBody": "{actor} غيّر حدّ تخزين «{subject}».",
    "notify.clients.quotaThresholdTitle": "مساحة العميل توشك على النفاد",
    "notify.clients.quotaThresholdBody": "«{subject}» وصل إلى {percent}% من مساحته. بعد {block}% يتوقف الرفع، وتبقى القراءة والحذف متاحتين.",
    "notify.clients.archiveReminderTitle": "عميل مؤرشف منذ مدة",
    "notify.clients.archiveReminderBody": "«{subject}» مؤرشف منذ {weeks, plural, one {أسبوع واحد} two {أسبوعين} few {# أسابيع} many {# أسبوعاً} other {# أسبوع}}. هل تحذفه أم تستعيده؟ يتكرّر هذا التنبيه أربع مرات فقط.",
    "notify.boards.archivedTitle": "أُرشفت لوحة",
    "notify.boards.archivedBody": "{actor} أرشف لوحة «{subject}».",
    "notify.cards.assignedTitle": "بطاقة جديدة مسنَدة إليك",
    "notify.cards.assignedBody": "{actor} أسند إليك «{subject}».",
    "notify.cards.updatedTitle": "عُدّلت بطاقة",
    "notify.cards.updatedBody": "{actor} عدّل «{subject}».",
    "notify.cards.movedTitle": "نُقلت بطاقة",
    "notify.cards.movedBody": "{actor} نقل «{subject}» إلى عمود آخر — ولم تتغيّر حالتها.",
    "notify.cards.stateTitle": "تغيّرت حالة بطاقة",
    "notify.cards.stateBody": "{actor} غيّر حالة «{subject}».",
    "notify.cards.archivedTitle": "أُرشفت بطاقة",
    "notify.cards.archivedBody": "{actor} أرشف «{subject}» للجميع — وتوقّف تكرارها.",
    "notify.cards.restoredTitle": "استُعيدت بطاقة",
    "notify.cards.restoredBody": "{actor} استعاد «{subject}» — وعاد تكرارها معها.",
    "notify.cards.commentTitle": "تعليق جديد",
    "notify.cards.commentBody": "{actor} علّق على «{subject}».",
    "notify.cards.mentionTitle": "{actor} أشار إليك",
    "notify.cards.mentionBody": "في تعليق على «{subject}».",
    "notify.cards.dueRequestedTitle": "طلب تغيير موعد",
    "notify.cards.dueRequestedBody": "{actor} طلب تغيير موعد «{subject}». أنت أو رئيس القسم — أوّل من يبتّ فيه يُغلق الطلب.",
    "notify.cards.dueDecidedTitle": "حُسم طلب تغيير الموعد",
    "notify.cards.dueDecidedBody": "{actor} حسم طلب تغيير موعد «{subject}».",
    "notify.cards.dueChangedTitle": "تغيّر موعد بطاقة",
    "notify.cards.dueChangedBody": "{actor} غيّر موعد «{subject}» — وأُعيدت جدولة التذكيرات.",
    "notify.cards.reminderTitle": "اقترب الموعد",
    "notify.cards.reminderBody": "اقترب موعد «{subject}».",
    "notify.cards.overdueTitle": "بطاقة تجاوزت موعدها",
    "notify.cards.overdueBody": "«{subject}» تجاوز موعده منذ {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يوماً} other {# يوم}} — ولا يزال مفتوحاً.",
    "notify.cards.escalationTitle": "بطاقة متأخّرة في فريقك",
    "notify.cards.stalledTitle": "مهمة متكرّرة متوقّفة",
    "notify.cards.stalledBody": "«{subject}» عليها {missed, plural, one {نسخة واحدة متأخّرة ولا أحد يُغلقها} two {نسختان متأخّرتان متتاليتان ولا أحد يُغلقهما} few {# نسخ متأخّرة متتالية ولا أحد يُغلقها} many {# نسخة متأخّرة متتالية ولا أحد يُغلقها} other {# نسخة متأخّرة متتالية ولا أحد يُغلقها}} — يتكرّر هذا التنبيه كل ٣ أيام حتى تُحل.",
    "notify.cards.escalationBody": "«{subject}» تجاوز موعده ولم يحرّكه المسنَد إليه — يصلك التصعيد بعد يومين، ثم كل يوم.",
    "notify.clients.quotaThresholdActor": "النظام",
    "common.working": "جارٍ التنفيذ…",
    "confirm.typeName": "اكتب «{name}» للتأكيد",
    "confirm.otherNameAccepted": "و«{name}» مقبول أيضاً.",
    "clients.new": "عميل جديد",
    "clients.edit": "تعديل بيانات العميل",
    "clients.muteReminder": "أوقف تذكير الأرشفة",
    "clients.publishingToAgency": "اجعل الوكالة هي التي تنشر",
    "clients.publishingToClient": "اجعل العميل ينشر بنفسه",
    "clients.filter": "تصفية العملاء",
    "clients.emptyTitle": "لا يوجد عملاء بعد",
    "clients.emptyBody": "العميل هو الوحدة التي يرتبط بها كل العمل: لوحاته وبطاقاته وملفّاته وفريقه.",
    "clients.emptyArchivedTitle": "لا يوجد عملاء مؤرشفون",
    "clients.emptyArchivedBody": "عمل العميل المؤرشف يُقرأ ولا يُعدّل، ويبقى موجوداً حتى يُحذف بعد تصديره.",
    "clients.cardCount": "{n, plural, one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}}",
    "clients.boardsLabel": "اللوحات",
    "clients.quotaGb": "المساحة بالجيجابايت",
    "clients.uploadsStopped": "امتلأت المساحة — الرفع متوقّف، والقراءة والحذف متاحان.",
    "clients.archive": "أرشفة",
    "clients.archiveTitle": "أرشفة العميل",
    "clients.restore": "استعادة",
    "clients.export": "تصدير",
    "clients.delete": "حذف نهائي",
    "clients.deleteTitle": "حذف العميل نهائياً",
    "clients.deleteConfirm": "«{name}» وكل عمله سيُحذفان نهائياً بلا رجعة. سيبقى الاسم فقط في السجلّ.",
    "clients.deleteBlocked": "غير جاهز للحذف — ينقصه: {missing}",
    "clients.archivedNoticeTitle": "هذا العميل مؤرشف.",
    "clients.archivedNoticeBody": "{who} أرشفه في {when} — عمله يُقرأ ولا يُعدّل. استعِده إن كان العمل مستمراً.",
    "clients.exportReadyTag": "جاهز",
    "clients.exportRunningTag": "قيد التشغيل",
    "clients.exportFailedTag": "فشل",
    "clients.addMember": "أضِف إلى الفريق",
    "clients.addMemberPick": "اختر الموظف",
    "clients.addMemberMeans": "من تضيفه سيرى عمل هذا العميل — وكذلك رئيس قسمه، لأن أقسام العميل تُحدَّد من أقسام فريقه.",
    "clients.makeManager": "اجعله مدير الحساب",
    "clients.memberInactive": "موقوف",
    "clients.teamEmpty": "لا أحد في الفريق — وبدون فريق لن يرى أحد عمل هذا العميل.",
    "clients.keyLabel": "رمز العميل",
    "clients.keyHint": "حروف إنجليزية صغيرة وشرطات — يظهر في الروابط وملفات التصدير.",
    "clients.timezoneLabel": "توقيت العميل",
    "clients.timezoneHint": "تُعرض شاشات العميل بهذا التوقيت. وشاشات الموظفين بتوقيت النظام.",
    "clients.newButton": "+ عميل جديد",
    "clients.activeSummary": "{n, plural, one {عميل واحد نشط} two {عميلان نشطان} few {# عملاء نشطون} many {# عميلاً نشطاً} other {# عميل نشط}} — من يحتاج إلى نظرة يظهر أولاً.",
    "clients.search": "ابحث عن عميل…",
    "clients.filterActiveCount": "النشط · {n}",
    "clients.filterArchivedCount": "المؤرشف · {n}",
    "clients.searchNoneTitle": "لا يوجد عميل بهذا الاسم",
    "clients.searchNoneBody": "جرّب جزءاً من الاسم بالعربية أو بالإنجليزية، أو رمز العميل.",
    "clients.amLine": "مدير الحساب: {name}",
    "clients.amNone": "لا يوجد مدير حساب بعد",
    "clients.planOfMonth": "خطة {month}",
    "clients.planLine": "{n, plural, one {عنصر واحد} two {عنصران} few {# عناصر} many {# عنصراً} other {# عنصر}} · {published} نُشر",
    "clients.noPlanThisMonth": "لا توجد خطة لهذا الشهر",
    "clients.boardsCards": "{boards, plural, one {لوحة واحدة} two {لوحتان} few {# لوحات} many {# لوحة} other {# لوحة}} · {cards, plural, one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}}",
    "clients.lateCount": "{n} متأخر",
    "clients.awaitingCount": "{n} بانتظار قرار العميل",
    "clients.storagePercent": "المساحة {n}%",
    "clients.back": "‹ العملاء",
    "clients.amShort": "مدير الحساب {name}",
    "clients.tzShort": "بتوقيت {tz}",
    "clients.editButton": "عدّل البيانات",
    "clients.more": "المزيد — تصدير · أرشفة",
    "clients.lateLabel": "متأخر",
    "clients.lateCards": "{n, plural, one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}}",
    "clients.storageOf": "{used} من {quota} جيجا",
    "clients.tabs": "أقسام العميل",
    "clients.tabPortal": "بوابة العميل وجهات الاتصال",
    "clients.tabSettings": "المساحة والتسميات",
    "clients.tabData": "التصدير والأرشفة",
    "clients.teamCount": "الفريق · {n}",
    "clients.addMemberButton": "+ أضِف إلى الفريق",
    "clients.teamHint": "أعضاء الفريق يرون عمل هذا العميل. ومدير الحساب يبتّ في طلبات تغيير المواعيد.",
    "clients.removeMemberNamed": "أزِل {name} من الفريق",
    "clients.publishingQuestion": "من ينشر عمل العميل؟",
    "clients.contactsCount": "جهات الاتصال · {n}",
    "clients.addContactButton": "+ أضِف جهة اتصال",
    "clients.contactRemoveNamed": "أزِل {name}",
    "clients.quotaTitle": "حدّ المساحة",
    "clients.quotaHint": "عندما تصل المساحة إلى حدّ الإيقاف يتوقف الرفع، وتبقى القراءة والحذف متاحتين.",
    "clients.gb": "جيجا",
    "clients.labelsTitle": "تسميات البطاقات",
    "clients.labelsSummary": "{n, plural, one {تسمية واحدة} two {تسميتان} few {# تسميات} many {# تسمية} other {# تسمية}}: {names}",
    "clients.labelsCount": "{n, plural, one {تسمية واحدة} two {تسميتان} few {# تسميات} many {# تسمية} other {# تسمية}}",
    "clients.manageLabels": "إدارة التسميات",
    "clients.exportTitle": "تصدير كل بيانات العميل",
    "clients.exportHint": "الخطط والبطاقات والتقارير والمحادثات — في ملف واحد.",
    "clients.exportLast": "آخر تصدير: {when} · {state}",
    "clients.exportNow": "صدّر الآن",
    "clients.exportDownload": "نزّل",
    "clients.exportDownloadLast": "نزّل آخر تصدير",
    "clients.archiveRowTitle": "أرشفة العميل",
    "clients.archiveHint": "يصبح عمله للقراءة فقط، ويتوقف التكرار. يمكنك استعادته في أي وقت.",
    "clients.archiveButton": "أرشف…",
    "clients.deleteRowTitle": "حذف نهائي",
    "clients.deleteHint": "متاح فقط بعد الأرشفة واكتمال التصدير — وبكتابة اسم العميل.",
    "clients.deleteButton": "احذف نهائياً…",
    "week.sunday": "الأحد",
    "week.monday": "الاثنين",
    "week.tuesday": "الثلاثاء",
    "week.wednesday": "الأربعاء",
    "week.thursday": "الخميس",
    "week.friday": "الجمعة",
    "week.saturday": "السبت",
    "boards.backToClients": "العملاء",
    "boards.columnCount": "{n, plural, one {عمود واحد} two {عمودان} few {# أعمدة} many {# عموداً} other {# عمود}}",
    "boards.columnEmpty": "لا توجد بطاقات هنا",
    "boards.emptyTitle": "لا توجد لوحات",
    "boards.emptyBody": "اللوحة هي مكان عمل العميل: أعمدتها أماكن، وكل بطاقة تحمل حالتها.",
    "boards.readOnlyBecauseArchived": "العميل مؤرشف، لذا عمله كله للقراءة فقط. استعِده من ملفّه إن كان العمل مستمراً.",
    "cards.new": "بطاقة جديدة",
    "cards.detail": "البطاقة",
    "cards.titleLabel": "عنوان البطاقة",
    "cards.editText": "عدّل العنوان والوصف",
    "cards.peopleAndLabels": "الفريق والتسميات",
    "cards.saveAssignees": "احفظ الفريق",
    "cards.labelsLabel": "التسميات",
    "cards.saveLabels": "احفظ التسميات",
    "cards.hideForMe": "أخفِها من عرضي",
    "cards.unhideForMe": "أعِدها إلى عرضي",
    "cards.descriptionLabel": "الوصف",
    "cards.dueLabel": "الموعد",
    "cards.dueTitle": "الموعد",
    "cards.assigneesLabel": "المسنَد إليه",
    "cards.assigneesFromTeam": "يمكنك إسناد البطاقة إلى أي موظف نشط.",
    "cards.blockedBecause": "متوقّف لأن:",
    "cards.blockReasonLabel": "سبب التوقّف",
    "cards.blockReasonHint": "من سيستلمها يحتاج إلى معرفة ما الذي تنتظره بالضبط — لا «متوقّف» فقط.",
    "cards.archivedNotice": "هذه البطاقة مؤرشفة.",
    "cards.archivedNoticeBody": "{who} أرشفها للجميع، وتوقّف تكرارها. الاستعادة ستعيدها مع تكرارها.",
    "cards.archiveAction": "أرشفة للجميع",
    "cards.restoreAction": "استعادة",
    "cards.reopenedAt": "أُعيد فتحه",
    "cards.checklistEmpty": "لا توجد بنود بعد.",
    "cards.addChecklistItem": "بند جديد",
    "cards.due.pendingShort": "موعد",
    "cards.due.newDate": "الموعد الجديد",
    "cards.due.reasonLabel": "سبب الطلب",
    "cards.due.reasonHint": "من سيبتّ في الطلب يحتاج إلى معرفة أساسه — لا يمكن البتّ في طلب بلا سبب.",
    "cards.due.changeDirectly": "غيّر الموعد",
    "cards.due.changeReschedules": "ستُعاد جدولة التذكيرات على الموعد الجديد، وسيُغلق أي طلب معلّق.",
    "cards.due.approve": "موافقة",
    "cards.due.reject": "رفض",
    "cards.due.withdraw": "اسحب الطلب",
    "cards.due.approvedTag": "موافَق",
    "cards.due.rejectedTag": "مرفوض",
    "cards.due.withdrawnTag": "مسحوب",
    "cards.repeats": "هذه البطاقة تتكرّر",
    "cards.repeatsHint": "يُضبط التكرار مع الإنشاء في الطلب نفسه — وإن رُفض، تُرفض البطاقة كلها وترى السبب.",
    "cards.everyN": "كل كم مرة",
    "cards.monthDay": "يوم الشهر",
    "cards.weekDay": "يوم الأسبوع",
    "cards.recurrenceZone": "تُحسب المواعيد بتوقيت {zone} — ويُقرأ فعلاً، لا يُخزَّن فقط.",
    "myWork.subtitle": "كل المطلوب منك من بطاقات ومهام ومهام عناصر الخطط — حسب الموعد.",
    "myWork.lane": "نوع العمل",
    "myWork.noCardsTitle": "لا توجد بطاقات مطلوبة منك",
    "myWork.noCardsBody": "عندما يُسند إليك أحد بطاقة عميل ستظهر هنا — والمنتهية تخرج من القائمة.",
    "myWork.noTasksTitle": "لا توجد مهام مطلوبة منك",
    "myWork.noTasksBody": "المهام المباشرة عمل داخلي غير مرتبط بعميل — والمطلوب منك منها يظهر هنا.",
    "myWork.all": "الكل",
    "myWork.allCount": "الكل · {count}",
    "myWork.planTasks": "مهام الخطط",
    "myWork.kind.card": "بطاقة",
    "myWork.kind.plan": "مهمة خطة",
    "myWork.kind.task": "مهمة",
    "myWork.noneTitle": "لا يوجد عمل مطلوب منك",
    "myWork.noneBody": "عندما تُسند إليك بطاقة أو مهمة أو مهمة في خطة ستجدها هنا بموعدها.",
    "myWork.noPlanTasksTitle": "لا توجد مهام خطط مطلوبة منك",
    "myWork.noPlanTasksBody": "مهام عناصر الخطط التي أنت صاحبها تظهر هنا حتى تُعتمد.",
    "myWork.returnedBecause": "أُعيدت: «{reason}»",
    "myWork.delivered": "سُلِّمت وبانتظار المراجعة",
    "nav.clients": "العملاء",
    "nav.boards": "اللوحات",
    "labels.title": "تسميات العميل",
    "labels.none": "لا توجد تسميات بعد — أضِف أول تسمية في الأسفل.",
    "labels.onCards": "على {n, plural, one {بطاقة واحدة} two {بطاقتين} few {# بطاقات} many {# بطاقة} other {# بطاقة}}",
    "labels.new": "تسمية جديدة",
    "labels.edit": "تعديل التسمية",
    "labels.tone": "اللون",
    "labels.tone.neutral": "رمادي",
    "labels.tone.info": "أزرق",
    "labels.tone.success": "أخضر",
    "labels.tone.warning": "أصفر",
    "labels.tone.danger": "أحمر",
    "labels.delete": "حذف التسمية",
    "labels.deleteConfirm": "ستُزال التسمية من {n, plural, one {بطاقة واحدة} two {بطاقتين} few {# بطاقات} many {# بطاقة} other {# بطاقة}} وتُحذف من قائمة تسميات العميل.",
    "boards.rename": "غيّر اسم اللوحة",
    "boards.archiveBoard": "أرشِف اللوحة",
    "boards.archiveConfirm": "ستُؤرشف اللوحة وتختفي من القائمة — يمكنك استعادتها لاحقاً. هل تتابع؟",
    "boards.restoreBoard": "استعِد اللوحة",
    "boards.archivedNotice": "هذه اللوحة مؤرشفة — مقفلة للتعديل حتى تُستعاد.",
    "boards.manageLabels": "التسميات",
    "boards.templates": "قوالب اللوحات",
    "boards.newTemplate": "قالب جديد",
    "boards.editTemplate": "تعديل القالب",
    "boards.templateKey": "المفتاح — حروف إنجليزية صغيرة وشرطة، مثل content-flow",
    "boards.templateActive": "يظهر عند إنشاء لوحة جديدة",
    "boards.templateInactive": "موقوف",
    "boards.templateColumns": "أعمدة القالب بالترتيب",
    "boards.templateColumnAr": "اسم العمود {n} بالعربية",
    "boards.templateColumnEn": "اسم العمود {n} بالإنجليزية",
    "boards.removeColumnN": "أزِل العمود {n}",
    "boards.addTemplateColumn": "أضِف عموداً",
    "boards.deleteTemplate": "حذف القالب",
    "boards.deleteTemplateConfirm": "سيُحذف القالب. اللوحات التي أُنشئت منه ({n}) ستبقى كما هي بأعمدتها.",
    "boards.showArchived": "المؤرشفة",
    "boards.boardMenu": "خيارات اللوحة",
    "boards.columnNew": "عمود جديد",
    "boards.addColumn": "+ عمود جديد",
    "boards.columnRenameTitle": "غيّر اسم العمود",
    "boards.columnMenu": "خيارات عمود {name}",
    "boards.cardHere": "بطاقة جديدة هنا",
    "boards.addCardIn": "+ بطاقة في «{name}»",
    "boards.columnRemoveLast": "احذف العمود — هذا آخر عمود في اللوحة",
    "boards.columnRemoveBlocked": "احذف العمود — فيه {n, plural, one {بطاقة واحدة، انقلها} two {بطاقتان، انقلهما} few {# بطاقات، انقلها} many {# بطاقة، انقلها} other {# بطاقة، انقلها}} أولاً",
    "boards.meta": "{client} · {open, plural, one {بطاقة واحدة مفتوحة} two {بطاقتان مفتوحتان} few {# بطاقات مفتوحة} many {# بطاقة مفتوحة} other {# بطاقة مفتوحة}} · {columns, plural, one {عمود واحد} two {عمودان} few {# أعمدة} many {# عموداً} other {# عمود}}",
    "boards.search": "ابحث في البطاقات",
    "boards.searchHint": "ابحث في البطاقات…",
    "boards.filterMine": "بطاقاتي",
    "boards.filterLate": "متأخر · {n}",
    "boards.filterLabels": "بالتسمية",
    "boards.filterGrouped": "المتكرّر مجمّع",
    "boards.dragHint": "اسحب البطاقة بين الأعمدة — العمود مكان، لا حالة",
    "boards.columnTabs": "أعمدة اللوحة",
    "boards.filteredEmpty": "لا توجد بطاقات هنا تطابق هذه التصفية",
    "boards.seriesLate": "بطاقة متكرّرة · {n, plural, one {نسخة واحدة متأخرة} two {نسختان متأخرتان} few {# نسخ متأخرة} many {# نسخة متأخرة} other {# نسخة متأخرة}} — افتح المجموعة",
    "boards.seriesCopies": "بطاقة متكرّرة · {n, plural, one {نسخة واحدة مفتوحة} two {نسختان مفتوحتان} few {# نسخ مفتوحة} many {# نسخة مفتوحة} other {# نسخة مفتوحة}} — افتح المجموعة",
    "boards.moveCard": "انقلها إلى عمود",
    "boards.moveCardTitle": "انقل «{title}» إلى عمود",
    "boards.moveHere": "{name} — هي هنا الآن",
    "boards.clientsFilter": "العملاء",
    "boards.allClients": "كل العملاء",
    "boards.groupMeta": "{boards, plural, one {لوحة واحدة} two {لوحتان} few {# لوحات} many {# لوحة} other {# لوحة}} · {cards, plural, one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}}",
    "boards.subtitle": "كل لوحة لعميل، وأعمدتها من القالب الذي أُنشئت منه.",
    "boards.lateCount": "{n} متأخر",
    "boards.archivedBadge": "مؤرشفة",
    "cards.archivedBySystem": "أرشفها النظام تلقائياً لأنها اكتملت قبل بداية الشهر الماضي. الاستعادة ستعيدها.",
    "cards.priorityInvalid": "اختر أولوية صحيحة.",
    "cards.prioritySaved": "حُفظت الأولوية.",
    "cards.priority": "الأولوية",
    "cards.context": "{client} · {board} · في «{column}»",
    "cards.stateTitle": "الحالة",
    "cards.teamTitle": "الفريق والتسميات",
    "cards.editPeople": "عدّل الفريق والتسميات",
    "cards.noAssignees": "لا أحد على هذه البطاقة بعد.",
    "cards.madeBy": "أنشأها {name} · {date}",
    "nav.plans": "الخطط",
    "nav.myWork": "أعمالي",
    "notify.cards.attachedTitle": "مرفق جديد",
    "notify.cards.attachedBody": "{actor} رفع ملفاً على «{subject}».",
    "notify.cards.recurrenceSpawnedTitle": "بطاقة متكرّرة جديدة",
    "notify.cards.recurrenceSpawnedBody": "«{subject}» بدأت دورتها الجديدة، وموعدها {due}.",
    "notify.clients.exportReadyTitle": "نسخة العميل جاهزة",
    "notify.clients.exportReadyBody": "نسخة بيانات «{subject}» التي طلبتها اكتملت وجاهزة للتنزيل.",
    "notify.clients.exportFailedTitle": "فشلت نسخة العميل",
    "notify.clients.exportFailedBody": "لم تكتمل نسخة «{subject}» — الرمز {code}. يبقى الحذف محجوباً حتى تنجح نسخة.",
    "notify.plans.assignedTitle": "عنصر خطة جديد مسنَد إليك",
    "notify.plans.assignedBody": "أُسند إليك «{subject}» — التسليم {due}.",
    "notify.plans.taskAssignedTitle": "مهمة جديدة مسنَدة إليك",
    "notify.plans.taskAssignedBody": "أُسندت إليك «{task}» في «{subject}» — موعدها {due}.",
    "notify.plans.taskDeliveredTitle": "سُلِّمت مهمة وبانتظار المراجعة",
    "notify.plans.taskDeliveredBody": "«{task}» في «{subject}» جاهزة للمراجعة الداخلية.",
    "notify.plans.taskApprovedTitle": "اعتُمدت مهمتك",
    "notify.plans.taskApprovedBody": "اعتُمدت «{task}» في «{subject}» داخلياً.",
    "notify.plans.taskReturnedTitle": "أُعيدت مهمتك للتعديل",
    "notify.plans.taskReturnedBody": "«{task}» في «{subject}» أُعيدت: {reason}",
    "plans.task.added": "أُضيفت المهمة.",
    "plans.task.saved": "حُفظت المهمة.",
    "plans.task.reassigned": "نُقلت المهمة إلى صاحبها الجديد وأبلغناه.",
    "plans.task.removed": "أُزيلت المهمة.",
    "plans.task.started": "بدأت المهمة.",
    "plans.task.previewAdded": "رُفعت المعاينة.",
    "plans.task.deliveredToast": "سلّمت المهمة — أُبلغ المراجعون.",
    "plans.task.approvedToast": "اعتُمدت المهمة.",
    "plans.task.reviewedToast": "سُجّلت المراجعة.",
    "plans.task.returnedToast": "أُعيدت المهمة إلى صاحبها مع السبب.",
    "plans.task.itemApprovedToast": "اعتُمدت آخر مهمة — اعتُمد العنصر داخلياً وأُبلغ العميل.",
    "notify.plans.updatedTitle": "عُدّل عنصر خطة",
    "notify.plans.updatedBody": "{actor} عدّل «{subject}».",
    "notify.plans.stateTitle": "تغيّرت حالة عنصر",
    "notify.plans.stateBody": "{actor} نقل «{subject}».",
    "notify.plans.awaitingTitle": "بانتظار قرار العميل",
    "notify.plans.awaitingBody": "«{subject}» جاهز ويحتاج إلى قرار العميل — سجّله إن وافق خارج النظام.",
    "notify.plans.decidedTitle": "سُجّل قرار العميل",
    "notify.plans.decidedBody": "{actor} سجّل قرار العميل على «{subject}».",
    "notify.plans.withdrawnTitle": "سُحب الاعتماد",
    "notify.plans.withdrawnBody": "{actor} سحب اعتماد «{subject}» وأعاده إلى التنفيذ.",
    "notify.plans.cancelledTitle": "أُلغي عنصر خطة",
    "notify.plans.cancelledBody": "{actor} ألغى «{subject}».",
    "notify.plans.escalatedTitle": "استثناء مراجعة معلّق منذ مدة",
    "notify.plans.escalatedBody": "«{subject}» متوقّف على استثناء منذ {hours, plural, one {ساعة واحدة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}} بلا قرار — والعمل متوقّف عليه.",
    "notify.plans.exceptionTitle": "حُسم استثناء المراجعات",
    "notify.plans.exceptionBody": "{actor} حسم استثناء «{subject}».",
    "notify.plans.mediaTitle": "وسيط جديد على عنصر",
    "notify.plans.mediaBody": "{actor} أضاف وسيطاً على «{subject}».",
    "notify.plans.commentTitle": "تعليق جديد",
    "notify.plans.commentBody": "{actor} علّق على «{subject}».",
    "notify.plans.mentionTitle": "{actor} أشار إليك",
    "notify.plans.mentionBody": "في تعليق على «{subject}».",
    "notify.clients.publishingTitle": "تغيّرت مسؤولية النشر",
    "notify.clients.publishingBody": "{actor} غيّر من ينشر عمل «{subject}».",
    "notify.storage.orphanTitle": "ملفات يتيمة في التخزين",
    "notify.storage.orphanBody": "وجدت المطابقة {count, plural, one {ملفاً واحداً} two {ملفين} few {# ملفات} many {# ملفاً} other {# ملف}}، منها «{subject}» — التخزين وقاعدة البيانات غير متطابقين. يحتاج إلى قرار بشري.",
    "cards.attachments": "المرفقات",
    "cards.attachNone": "لا توجد مرفقات.",
    "cards.attachAdd": "أضِف ملفاً",
    "cards.detach": "افصل المرفق",
    "cards.detachedStillHeld": "فُصل عن هذه البطاقة — ولا يزال موجوداً في {n, plural, one {بطاقة أخرى} two {بطاقتين أخريين} few {# بطاقات أخرى} many {# بطاقة أخرى} other {# بطاقة أخرى}}.",
    // ═══════════ المرحلة السادسة — البورتال ═══════════
    "errors.portalOperationRefused": "هذه العملية للاستخدام الداخلي، وغير متاحة من بوابة العميل.",
    "errors.portalDisabled": "بوابة العميل غير مفعّلة لهذا العميل.",
    "errors.pushNotConfigured": "تنبيهات الجهاز غير مضبوطة في النظام — تواصل مع الإدارة.",
    "errors.previewStopped": "صلاحيات هذا الموظف تسمح بهذه العملية، ولم تُنفَّذ لأن لها أثراً حقيقياً.",
    "errors.previewPrivate": "المحادثات الخاصة لا تُفتح في هذا الوضع.",
    "preview.banner": "أنت ترى النظام بعين {name}. لا يُحفظ أي شيء. ينتهي الوضع الساعة {until}.",
    "preview.exit": "رجوع إلى حسابي",
    "preview.start": "الدخول بعين هذا الموظف",
    "preview.startHint": "ترى النظام بصلاحياته ولا يُحفظ شيء. ويُسجَّل باسمك.",
    "plans.scope": "عرض الخطط",
    "plans.scope.current": "الحالية",
    "plans.scope.archive": "الأرشيف",
    "preview.wouldSucceed": "كانت ستنجح لهذا الموظف. لم يُكتب شيء.",
    "preview.started": "أنت الآن ترى النظام بعين هذا الموظف.",
    "preview.stopped": "رجعت إلى حسابك.",
    "errors.workArchived": "هذا الشغل في الأرشيف. يمكن قراءته ولا يمكن تعديله.",
    "errors.tenantUnknown": "هذا العنوان غير مربوط بأي وكالة. تأكد من رابط الدخول.",
    "errors.backupNotConfigured": "وجهة النسخ الاحتياطي غير مضبوطة — لا تُؤخذ نسخة حتى تُضبط.",
    "errors.backupFailed": "تعذّر أخذ النسخة الاحتياطية. السبب في «صحة النظام».",
    "notify.platform.backupFailedTitle": "تعذّر أخذ النسخة الاحتياطية",
    "notify.platform.backupFailedBody": "افتح «صحة النظام» لقراءة السبب. والمحاولة تتكرّر كل ساعة.",
    "platform.health.service.backup": "النسخ الاحتياطي",
    "platform.health.job.backup": "النسخ الاحتياطي",
    "platform.health.serviceHint.backup": "نسخة من القاعدة والملفات إلى وجهة خارج هذا الخادم كل ست ساعات.",
    "errors.pushDeliveryFailed": "لم يصل تنبيه التجربة إلى أي جهاز. أعِد المحاولة بعد دقيقة.",
    "portal.nav.home": "الرئيسية",
    "portal.nav.plans": "الخطط",
    "portal.nav.notifications": "التنبيهات",
    "portal.nav.contacts": "فريقنا",
    "portal.nav.schedule": "المنشورات",
    "portal.nav.chat": "المحادثة",
    "portal.nav.meetings": "الاجتماعات",
    "nav.meetings": "الاجتماعات",
    "meetings.title": "الاجتماعات",
    "meetings.subtitle": "مواعيدك مع العملاء — وما ينتظر ردّك في الأعلى.",
    "meetings.state.REQUESTED": "بانتظار الردّ",
    "meetings.state.RESCHEDULE_PROPOSED": "موعد آخر مقترَح",
    "meetings.state.CONFIRMED": "مؤكّد",
    "meetings.state.COMPLETED": "عُقد",
    "meetings.state.REJECTED": "مرفوض",
    "meetings.state.CANCELLED": "ملغى",
    "meetings.state.NO_SHOW": "لم يُعقد",
    "meetings.side.AGENCY": "من جهتنا",
    "meetings.side.CLIENT": "من العميل",
    "meetings.propose": "اطلب اجتماعاً",
    "meetings.proposed": "أُرسل الاقتراح.",
    "meetings.subject": "موضوع الاجتماع",
    "meetings.subjectRequired": "اكتب موضوع الاجتماع.",
    "meetings.when": "الموعد",
    "meetings.whenInPast": "يجب أن يكون الموعد في المستقبل.",
    "meetings.duration": "المدة بالدقائق",
    "meetings.link": "رابط الاجتماع",
    "meetings.linkHint": "زوم أو مِيت — يراه العميل بعد التأكيد فقط.",
    "meetings.client": "العميل",
    "meetings.confirm": "أكّد الموعد",
    "meetings.confirmed": "تمّ تأكيد الاجتماع.",
    "meetings.reschedule": "اقترح موعداً آخر",
    "meetings.rescheduled": "أُرسل الاقتراح.",
    "meetings.reject": "ارفض",
    "meetings.rejected": "تمّ الرفض.",
    "meetings.cancel": "ألغِ الاجتماع",
    "meetings.cancelled": "تمّ الإلغاء.",
    "meetings.complete": "عُقد",
    "meetings.completed": "سُجّل أنه عُقد.",
    "meetings.noShow": "لم يحضر الطرف الآخر",
    "meetings.noShowSaved": "سُجّل أنه لم يُعقد.",
    "meetings.reason": "السبب",
    "meetings.reasonRequired": "اكتب السبب.",
    "meetings.proposals": "الاقتراحات",
    "meetings.awaitingThem": "بانتظار ردّ الطرف الآخر",
    "meetings.awaitingYou": "بانتظار ردّك",
    "meetings.noneTitle": "لا توجد اجتماعات",
    "meetings.noneBody": "عندما تطلب اجتماعاً أو يطلبه عميل، ستجده هنا.",
    "meetings.linkHiddenUntilConfirmed": "يظهر الرابط بعد التأكيد",
    "meetings.proposeButton": "+ اطلب اجتماعاً",
    "meetings.awaitingYouCount": "بانتظار ردّك · {count}",
    "meetings.requestedBy": "بطلب من {name}",
    "meetings.minutes": "{count, plural, one {دقيقة واحدة} two {دقيقتان} few {# دقائق} many {# دقيقة} other {# دقيقة}}",
    "meetings.confirmShort": "أكّد",
    "meetings.decline": "اعتذر",
    "meetings.upcoming": "القادمة",
    "meetings.upcomingNone": "لا توجد مواعيد قادمة.",
    "meetings.join": "انضمّ إلى الاجتماع",
    "meetings.options": "خيارات «{subject}»",
    "meetings.changeTime": "غيّر الموعد",
    "meetings.pastTitle": "السابقة — هل عُقدت؟",
    "meetings.pastCount": "السابقة — هل عُقدت؟ · {count}",
    "meetings.didNotHappen": "لم يُعقد",
    "meetings.archive": "الأرشيف",
    "meetings.archiveCount": "الأرشيف · {count}",
    "meetings.archiveHint": "الملغاة والمرفوضة والمغلقة هنا — لكي لا تزدحم القائمة.",
    "portal.meetings.subtitle": "مواعيدك مع فريقك في الوكالة.",
    "portal.meetings.request": "اطلب اجتماعاً",
    "portal.meetings.requested": "وصل طلبك.",
    "portal.meetings.noneTitle": "لا توجد اجتماعات",
    "portal.meetings.noneBody": "اطلب اجتماعاً وسيردّ عليك فريقك بموعد.",
    "portal.meetings.join": "انضمّ إلى الاجتماع",
    "portal.meetings.side.AGENCY": "اقترحته الوكالة",
    "portal.meetings.side.CLIENT": "طلبه فريقك",
    "portal.reports.editPending": "طلبت تعديلاً — بانتظار الوكالة",
    "portal.schedule.subtitle": "مواعيد نشر أعمالك، وحالة كلٍّ منها، ورابط المنشور بعد نشره.",
    "portal.schedule.state.PENDING": "بانتظار الجدولة",
    "portal.schedule.state.SCHEDULED": "مجدول",
    "portal.schedule.state.PUBLISHED": "نُشر",
    "portal.schedule.state.CANCELLED": "أُلغي",
    "portal.schedule.state.FAILED": "نتابعه الآن",
    "portal.schedule.noDate": "لم يُحدَّد الموعد بعد",
    "portal.schedule.openPost": "افتح المنشور",
    "portal.takedown.ask": "اطلب إزالته",
    "portal.takedown.reason": "لماذا تريد إزالة هذا المنشور؟ — سيصل إلى فريق النشر فوراً",
    "portal.takedown.send": "أرسِل طلب الإزالة",
    "portal.takedown.open": "وصل طلب الإزالة — فريق النشر يعمل عليه",
    "portal.takedown.removed": "أُزيل",
    "portal.takedown.refused": "لن يُزال",
    "portal.schedule.noneTitle": "لا يوجد شيء مجدول",
    "portal.schedule.noneBody": "بمجرد أن توافق على عمل وتتحدّد مواعيد نشره، ستجدها هنا بحالتها.",
    "portal.schedule.selfTitle": "أنتم من ينشر أعمالكم",
    "portal.schedule.selfBody": "الوكالة لا تنشر لكم، لذا لا تظهر مواعيد النشر هنا. ستجد الأعمال التي وافقت عليها في الخطط بمواعيدها.",
    "portal.reports.noneTitle": "لا توجد تقارير بعد",
    "portal.reports.noneBody": "بمجرد أن يُرسَل إليك تقرير، سيظهر هنا كاملاً.",
    "portal.nav.reports": "التقارير",
    "portal.nav.profile": "ملفّي",
    "portal.agency": "الوكالة",
    "portal.you": "أنت",
    "portal.home.awaitingNone": "لا يوجد ما ينتظر قرارك.",
    "portal.home.soon": "اقترب موعد نشره",
    "portal.home.soonNone": "لا يوجد ما اقترب موعد نشره.",
    "portal.home.awaitingCount": "{n, plural, one {عنصر ينتظر قرارك} two {عنصران ينتظران قرارك} few {عناصر تنتظر قرارك} many {عنصراً ينتظر قرارك} other {عنصر ينتظر قرارك}}",
    "portal.home.oldest": "أقدمها وصلك {since}",
    "portal.home.publishing": "يُنشر {when}",
    "portal.home.meetingsWaiting": "لديك {n, plural, one {اجتماع واحد} two {اجتماعان} few {# اجتماعات} many {# اجتماعاً} other {# اجتماع}} بانتظار ردّك",
    "portal.home.meetingsNone": "لا يوجد اجتماع بانتظار ردّك.",
    "portal.item.parts": "الأجزاء",
    "portal.item.partApproved": "وافقت عليه",
    "portal.item.revisionsAfter": "بعد آخر مراجعة، يُحال أي طلب تعديل إلى الإدارة قبل تنفيذه.",
    "portal.item.approvedNote": "وافقت عليه — سيُنشر في موعده",
    "portal.schedule.publishedSection": "نُشر · الأحدث في الأعلى",
    "portal.meetings.awaitingSection": "بانتظار ردّك",
    "portal.meetings.upcomingSection": "القادمة",
    "portal.meetings.pastSection": "السابقة",
    "portal.alerts": "التنبيهات — {n} جديد",
    "portal.plans.none": "لا توجد خطط متاحة لك بعد.",
    "portal.plans.noneBody": "بمجرد أن تجهّز الوكالة عملاً وتعتمده، سيظهر هنا.",
    "portal.plans.itemsNone": "لا يوجد في هذه الخطة ما هو متاح لك بعد.",
    "portal.item.preview": "المعاينة",
    "portal.item.caption": "نصّ المنشور",
    "portal.item.altCaption": "نصّ بديل",
    "portal.item.publishAt": "موعد النشر",
    "portal.item.history": "ما حدث",
    "portal.item.historyNone": "لا توجد قرارات بعد.",
    "portal.item.comments": "التعليقات",
    "portal.item.commentsNone": "لا توجد تعليقات.",
    "portal.item.commentPlaceholder": "اكتب تعليقك…",
    "portal.item.approve": "موافق",
    "portal.item.reject": "يحتاج إلى تعديل",
    "portal.item.requestEdit": "اطلب تعديلاً",
    "portal.item.rejectComment": "اذكر المطلوب بالتفصيل",
    "portal.item.partsLegend": "أيّ جزء يحتاج إلى تعديل؟",
    "portal.item.rejectHint": "التعليق إلزامي — من سيعدّل يحتاج أن يعرف ماذا يغيّر.",
    "portal.item.revisions": "المراجعات",
    "portal.item.revisionsUsed": "استخدمت {used} من {limit}",
    "portal.item.exceptionPending": "أُحيل طلبك إلى الإدارة — سنعود إليك بقرار.",
    "portal.item.approved": "تمّت الموافقة، شكراً لك.",
    "portal.item.rejected": "وصل طلبك إلى الفريق.",
    "portal.item.parked": "تجاوز طلبك حدّ المراجعات المتّفق عليه — أُحيل إلى الإدارة.",
    "portal.item.editRequested": "وصل طلب التعديل.",
    "portal.item.commented": "سُجّل تعليقك.",
    "portal.item.awaitingYou": "بانتظار قرارك",
    "portal.decision.approvedByMe": "وافقت",
    "portal.decision.rejectedByMe": "طلبت تعديلاً",
    "portal.contacts.title": "فريقنا على البوابة",
    "portal.contacts.none": "لا يوجد أحد آخر من فريقكم على البوابة.",
    "portal.contacts.primary": "جهة الاتصال الأساسية",
    "push.title": "تنبيهات هذا الجهاز",
    "push.enable": "فعّل التنبيه على هذا الجهاز",
    "push.disable": "أوقِف التنبيه على هذا الجهاز",
    "push.enabled": "تمّ تفعيل التنبيه على هذا الجهاز.",
    "push.disabled": "تمّ إيقاف التنبيه على هذا الجهاز.",
    "push.blocked": "المتصفّح يرفض التنبيهات. اسمح بها من إعدادات الموقع وحاول مرة أخرى.",
    "push.unsupported": "هذا المتصفّح لا يدعم تنبيهات الجهاز.",
    "push.thisDevice": "هذا الجهاز",
    "push.devicesNoneTitle": "لا توجد أجهزة مفعّلة",
    "push.devicesNone": "لم تفعّل التنبيهات على أي جهاز بعد. فعّلها من الزرّ في الأعلى.",
    "push.removeDevice": "أوقِف التنبيه عن هذا الجهاز",
    "push.stop": "أوقِفه",
    "push.devices": "الأجهزة المفعّلة",
    "push.deviceRequired": "اسم الجهاز ناقص.",
    "push.endpointRequired": "بيانات الاشتراك ناقصة — حاول مرة أخرى.",
    "push.keysRequired": "مفاتيح الاشتراك ناقصة — حاول مرة أخرى.",
    "push.intro": "يصلك تنبيهٌ حين يُسنَد إليك عمل، أو يُذكَر اسمك، أو يقترب موعد تسليم — حتى والتطبيق مغلق. والتنبيهُ يحمل عنواناً ورابطاً فقط، لا محتوى العمل.",
    "push.stateOn": "يعمل",
    "push.stateOff": "متوقّف",
    "push.stateBlocked": "ممنوع من المتصفّح",
    "push.test": "أرسل تنبيه تجربة",
    "push.tested": "{n, plural, one {وصل تنبيه التجربة إلى جهاز واحد} two {وصل تنبيه التجربة إلى جهازين} few {وصل تنبيه التجربة إلى # أجهزة} many {وصل تنبيه التجربة إلى # جهازاً} other {وصل تنبيه التجربة إلى # جهاز}}.",
    "push.testedNone": "لا يوجد جهاز مفعّل بعد — فعّل التنبيه على هذا الجهاز أولاً.",
    "push.testTitle": "تنبيه تجربة من مِنوال",
    "push.testBody": "التنبيهات تصل إلى هذا الجهاز.",
    "push.askTitle": "هل تريد التنبيهات على هذا الجهاز؟",
    "push.askBody": "يصلك تنبيهٌ حين يُسنَد إليك عمل، أو يُذكَر اسمك، أو يقترب موعد تسليم — حتى والتطبيق مغلق.",
    "push.askEnable": "فعّل التنبيهات",
    "push.askLater": "ليس الآن",
    "push.askNote": "تستطيع تغيير ذلك في أي وقت من «حسابي».",
    "notify.portal.decisionTitle": "قرّر العميل",
    "notify.portal.decisionBody": "{actor} قرّر بشأن «{subject}».",
    "notify.portal.editRequestTitle": "طلب العميل تعديلاً",
    "notify.portal.editRequestBody": "{actor} طلب تعديلاً على «{subject}» بعد الموافقة.",
    "notify.portal.commentTitle": "تعليق من العميل",
    "notify.portal.commentBody": "{actor} علّق على «{subject}».",
    "notify.portal.awaitingTitle": "عمل بانتظار قرارك",
    "notify.portal.awaitingBody": "«{subject}» جاهز وبانتظار قرارك.",
    // ── تغييرُ المرء كلمتَه — وسياستُها في القلب ──
    "auth.passwordTooShort": "يجب أن تتكوّن كلمة السرّ من ١٢ حرفاً على الأقل.",
    "auth.currentPassword": "كلمة السرّ الحالية",
    "auth.newPassword": "كلمة السرّ الجديدة",
    "auth.confirmPassword": "أكّد كلمة السرّ الجديدة",
    "auth.currentPasswordRequired": "اكتب كلمة السرّ الحالية.",
    "auth.currentPasswordWrong": "كلمة السرّ الحالية غير صحيحة.",
    "auth.passwordMismatch": "كلمتا السرّ غير متطابقتين.",
    "auth.passwordSameAsOld": "اختر كلمة سرّ مختلفة عن الحالية.",
    "auth.passwordChanged": "تمّ تغيير كلمة السرّ.",
    "auth.changePasswordTitle": "غيّر كلمة السرّ",
    "auth.changePasswordWhy": "أُنشئ حسابك بكلمة سرّ مؤقّتة. غيّرها قبل المتابعة.",
    // ── جملةٌ كاملة لا كلمتان تُلصَقان ──
    "portal.decision.agencyApproved": "الوكالة وافقت",
    "portal.decision.agencyRejected": "الوكالة طلبت تعديلاً",
    "portal.decision.personApproved": "{name} وافق",
    "portal.decision.personRejected": "{name} طلب تعديلاً",
    // ── الدعوة والدور — الطريقُ الوحيد لدخول إنسانٍ جديد ──
    "errors.inviteInvalid": "رابط الدعوة غير صالح — اطلب من الإدارة أن ترسل لك رابطاً جديداً.",
    "invite.title": "اختر كلمة السرّ الخاصة بك",
    "invite.sub": "هذا أول دخول لك. اختر كلمة سرّ وابدأ.",
    "invite.done": "تمّ! سُجّلت كلمة السرّ — ادخل بها الآن.",
    "invite.link": "رابط الدعوة",
    "invite.copy": "انسخ الرابط",
    "invite.copied": "نُسخ الرابط.",
    "invite.copyFailed": "رفض المتصفّح النسخ — حدّد الرابط وانسخه يدوياً.",
    "invite.hint": "أرسِل هذا الرابط إلى الموظف. يعمل مرة واحدة وتنتهي صلاحيته بعد ٧ أيام.",
    "invite.resend": "أنشئ رابط دعوة جديداً",
    "invite.resendHint": "سيتوقّف الرابط القديم عن العمل.",
    "invite.state.none": "لا توجد دعوة",
    "invite.state.pending": "الدعوة بانتظار القبول",
    "invite.state.expired": "الدعوة انتهت",
    "invite.state.used": "دخل بالفعل",
    "people.inviteSection": "الدخول والأمان",
    "people.role": "الدور",
    "people.roleNone": "بلا دور",
    "people.changeRole": "غيّر الدور",
    "people.roleChanged": "تمّ تغيير الدور.",
    "people.roleRequired": "اختر دوراً — الموظف بلا دور لا يستطيع فعل أي شيء.",
    "people.counts": "{total, plural, one {شخص واحد} two {شخصان} few {# أشخاص} many {# شخصاً} other {# شخص}} · {active} نشط · {pending} بانتظار قبول الدعوة · {stopped} موقوف",
    "people.search": "ابحث بالاسم أو البريد الإلكتروني…",
    "people.searchLabel": "ابحث",
    "people.pendingFilter": "بانتظار الدعوة",
    "people.invitePending": "لم يقبل الدعوة بعد",
    "people.noDepartment": "بلا قسم",
    "people.noMatch": "لا يوجد أحد بهذا الاسم هنا.",
    "people.lastSeen": "آخر دخول {when}",
    "people.neverSeen": "لم يدخل بعد",
    "people.roleAndDepartments": "الدور والأقسام",
    "people.primary": "الأساسي",
    "people.overrideMetaGrant": "حتى {when} · السبب: {reason} · منحه {name}",
    "people.overrideMetaRevoke": "حتى {when} · السبب: {reason} · سحبها {name}",
    "people.deleteOpen": "احذفه نهائياً…",
    // ── بورتال العميل: فتحُه وجهاتُ اتصاله ──
    "notify.clients.portalTitle": "تغيّرت بوابة العميل",
    "notify.clients.portalBody": "{actor} غيّر حالة بوابة «{subject}».",
    "clients.portalSaved": "سُجّلت حالة البوابة.",
    "clients.contactRemoved": "أُزيلت جهة الاتصال.",
    "clients.portalSection": "بوابة العميل",
    "clients.portalOn": "البوابة مفتوحة",
    "clients.portalOff": "البوابة مغلقة",
    "clients.portalOnHint": "يرى العميل أعماله المعتمدة ويستطيع الموافقة عليها أو رفضها.",
    "clients.portalOffHint": "جهات الاتصال موجودة لكنها لا تصل إلى شيء حتى تفتحها.",
    "clients.contacts": "جهات الاتصال",
    "clients.contactsNone": "لا توجد جهات اتصال بعد. أضِف واحدة لكي يتمكّن العميل من الدخول.",
    "clients.addContact": "أضِف جهة اتصال",
    "clients.contactPrimary": "اجعلها الأساسية",
    "clients.contactRemove": "أزِل من البوابة",
    "clients.contactRemoveConfirm": "هل تريد إزالة «{name}» من بوابة هذا العميل؟",
    "clients.contactOtherClients": "لدى {n, plural, one {عميل آخر} two {عميلين آخرين} few {# عملاء آخرين} many {# عميلاً آخر} other {# عميل آخر}} أيضاً",
    "clients.contactRole": "دور البوابة",
    "clients.contactRoleNone": "لا يوجد دور بوابة في النظام — أنشئ واحداً من شاشة الأدوار أولاً.",
    "invite.hintContact": "أرسِل هذا الرابط إلى جهة الاتصال. يعمل مرة واحدة وتنتهي صلاحيته بعد ٧ أيام.",
    "clients.contactIsPrimary": "الأساسية",
    "clients.contactKeepsAccount": "سيظلّ حسابها فعّالاً لدى عملائها الآخرين.",
    "clients.contactLosesAccount": "هذا آخر عميل لها — سيتوقّف حسابها وتنتهي جلستها. إذا أعدتها لاحقاً فسيعمل مرة أخرى.",
    "clients.contactsEmptyTitle": "لا توجد جهات اتصال",
    "clients.contactRoleEmpty": "لا يوجد دور بوابة",
    "clients.contactName": "اسم جهة الاتصال",
    "clients.contactChooseRole": "اختر الدور",
    "errors.releaseStateInvalid": "حالة الإصدار «{state}» — هذا الإجراء لا ينطبق عليها.",
    "errors.releaseNotYoursToPublish": "لا يمكنك نشر إصدار كتبته أنت — يقرؤه زميل آخر وينشره.",
    "errors.notificationParamMissing": "النص الجديد تنقصه أقواس مطلوبة: {missing}.",
    "platform.purgeReasonRequired": "اكتب سبب التنظيف.",
    "platform.releaseFieldRequired": "هذا الحقل مطلوب — بالعربية والإنجليزية.",
    "platform.audit.title": "سجلّ النشاط",
    "platform.audit.subtitle": "من فعل ماذا ومتى — وكل سطر يفتح العنصر نفسه.",
    "platform.audit.system": "النظام",
    "platform.audit.changes": "ما تغيّر",
    "platform.audit.from": "كان",
    "platform.audit.to": "أصبح",
    "platform.audit.correlation": "رقم الربط",
    "platform.audit.severity": "الدرجة",
    "platform.audit.filterFrom": "من",
    "platform.audit.filterTo": "إلى",
    "platform.audit.noneTitle": "لا يوجد نشاط في هذه المدة",
    "platform.audit.noneBody": "غيّر المدة أو الفاعل وحاول مرة أخرى.",
    "platform.audit.purge": "نظّف القديم",
    "platform.audit.purgeHint": "يحذف ما هو أقدم من المدة المحدّدة في الإعدادات، ويُسجَّل الحذف نفسه.",
    "platform.audit.purged": "تمّ تنظيف {deleted, plural, one {سطر واحد} two {سطرين} few {# أسطر} many {# سطراً} other {# سطر}}.",
    "platform.health.service.database": "قاعدة البيانات",
    "platform.health.service.storage": "التخزين",
    "platform.health.service.scanner": "فاحص الملفات",
    "platform.health.service.mail": "البريد",
    "platform.health.service.push": "التنبيهات",
    "platform.health.state.up": "تعمل",
    "platform.health.state.down": "معطّلة",
    "platform.health.state.off": "مطفأة",
    "platform.health.queues": "الطوابير",
    "platform.health.outboxPending": "بانتظار التسليم",
    "platform.health.outboxUndelivered": "متأخّر عن دقيقة",
    "platform.health.scansPending": "ملفات قيد الفحص",
    "platform.health.incidentsOpen": "حوادث مفتوحة",
    "platform.health.jobs": "المهام التي تعمل تلقائياً",
    "platform.health.lastEvent": "آخر مرة أنتج فيها شيئاً",
    "platform.health.lastRun": "آخر دورة",
    "platform.health.notRunYet": "لم يعمل بعد",
    "platform.health.runFailed": "فشل {ago}",
    "platform.health.never": "أبداً",
    "platform.health.incidents": "الحوادث",
    "platform.health.resolve": "حُلّت",
    "platform.health.resolved": "أُغلقت الحادثة.",
    "platform.health.occurrences": "تكرّرت {occurrences, plural, one {مرة واحدة} two {مرتين} few {# مرات} many {# مرة} other {# مرة}}",
    "platform.health.noIncidentsTitle": "لا توجد حوادث مفتوحة",
    "platform.health.noIncidentsBody": "أي عطل يفتح حادثة هنا بسببه الحقيقي ورقم ربطه.",
    "platform.changelog.title": "سجلّ التغييرات",
    "notify.platform.release.title": "نسخة جديدة متاحة",
    "notify.platform.release.body": "صدرت النسخة {version} — اضغط لترى ما الجديد.",
    "platform.changelog.subtitle": "ما الجديد في كل نسخة — يُكتب مسودّة، ثم يُراجَع، ثم يُنشر للجميع في «ما الجديد».",
    "platform.changelog.new": "+ إصدار جديد",
    "platform.changelog.version": "رقم النسخة",
    "platform.changelog.titleAr": "العنوان بالعربية",
    "platform.changelog.titleEn": "العنوان بالإنجليزية",
    "platform.changelog.bodyAr": "التفاصيل بالعربية",
    "platform.changelog.bodyEn": "التفاصيل بالإنجليزية",
    "platform.changelog.state.DRAFT": "مسودّة",
    "platform.changelog.state.IN_REVIEW": "في المراجعة",
    "platform.changelog.state.PUBLISHED": "نُشر",
    "platform.changelog.sendToReview": "أرسِل للمراجعة ←",
    "platform.changelog.sentToReview": "أُرسل للمراجعة.",
    "platform.changelog.publish": "انشر للجميع ←",
    "platform.changelog.published": "نُشر.",
    "platform.changelog.saved": "حُفظ.",
    "platform.changelog.noneTitle": "لا توجد إصدارات",
    "platform.changelog.noneBody": "اكتب أول إصدار وأخبر الفريق بما هو جديد.",
    "platform.changelog.whatsNew": "ما الجديد",
    "platform.changelog.gotIt": "حسناً، فهمت",
    "platform.changelog.by": "كتبه {name}",
    "platform.changelog.reviewedBy": "راجعه {name}",
    "platform.changelog.publishedAt": "نُشر {when}",
    "platform.notifications.title": "صياغة الإشعارات",
    "platform.notifications.subtitle": "غيّر نصّ أي إشعار باللغتين.",
    "platform.notifications.default": "الافتراضي",
    "platform.notifications.custom": "معدَّل",
    "platform.notifications.push": "يصل إلى الهاتف",
    "platform.notifications.email": "يصل إلى البريد الإلكتروني",
    "platform.notifications.audienceFixed": "من يتلقّاه تحدّده الصلاحيات — وليس هذه الشاشة.",
    "platform.notifications.reset": "أعِده إلى الأصل",
    "platform.notifications.saved": "حُفظت الصياغة.",
    "platform.notifications.wasReset": "عاد إلى الافتراضي.",
    "platform.notifications.noneTitle": "لا توجد إشعارات",
    "platform.notifications.noneBody": "سجلّ الإشعارات فارغ — وهو لا يكون فارغاً عادةً.",
    "platform.audit.severityWarning": "مهم",
    "platform.audit.severityCritical": "تنبيه",
    "platform.audit.allEntities": "كل شيء",
    "platform.audit.allSeverities": "كل الدرجات",
    "platform.audit.clearFilters": "امسح التصفية",
    "platform.audit.filterCorrelation": "اعرض كل ما تمّ بهذا الرقم",
    "platform.audit.purgeReason": "سبب التنظيف",
    "platform.audit.who": "مَن",
    "platform.audit.allPeople": "الجميع",
    "platform.audit.fromClient": "{name} (من العميل)",
    "platform.audit.onWhat": "على ماذا",
    "platform.audit.wholeGroup": "كل {group}",
    "platform.audit.period": "المدة",
    "platform.audit.periodAll": "منذ البداية",
    "platform.audit.periodDay": "آخر 24 ساعة",
    "platform.audit.periodWeek": "آخر 7 أيام",
    "platform.audit.periodMonth": "آخر 30 يوماً",
    "platform.audit.periodCustom": "مدة تختارها",
    "platform.audit.count": "{total, plural, one {حدث واحد} two {حدثان} few {# أحداث} many {# حدثاً} other {# حدث}}",
    "platform.audit.details": "التفاصيل",
    "platform.audit.hideDetails": "أغلِق",
    "platform.audit.fieldHead": "ما الذي تغيّر",
    "platform.audit.correlationHint": "إذا أبلغ أحد عن خطأ، فهذا الرقم يوصلك إلى هذا السطر.",
    "platform.audit.value.active": "نشط",
    "platform.audit.field.afterColumn": "بعد عمود",
    "platform.audit.field.approved": "تمّت الموافقة عليه",
    "platform.audit.field.archived": "مؤرشف",
    "platform.audit.field.assignees": "المسؤولون",
    "platform.audit.field.attendees": "الحضور",
    "platform.audit.field.before": "حُذف ما قبل",
    "platform.audit.field.capabilities": "الصلاحيات",
    "platform.audit.field.capability": "الصلاحية",
    "platform.audit.field.code": "الرمز",
    "platform.audit.field.column": "العمود",
    "platform.audit.field.columns": "الأعمدة",
    "platform.audit.field.cycle": "الدورة",
    "platform.audit.field.deactivated": "أُغلق حسابه",
    "platform.audit.field.delegate": "المفوَّض",
    "platform.audit.field.deleted": "حُذف",
    "platform.audit.field.departments": "الأقسام",
    "platform.audit.field.description": "الوصف",
    "platform.audit.field.detachedFrom": "أُزيل من",
    "platform.audit.field.dueAt": "الموعد",
    "platform.audit.field.email": "البريد",
    "platform.audit.field.event": "الإشعار",
    "platform.audit.field.export": "النسخة",
    "platform.audit.field.filename": "اسم الملف",
    "platform.audit.field.fromColumn": "من عمود",
    "platform.audit.field.gigabytes": "المساحة (جيجابايت)",
    "platform.audit.field.granted": "مُنح",
    "platform.audit.field.head": "رئيس القسم",
    "platform.audit.field.itemState": "حالة العنصر",
    "platform.audit.field.key": "البند",
    "platform.audit.field.kind": "النوع",
    "platform.audit.field.livePublished": "نُشر فعلاً",
    "platform.audit.field.locale": "اللغة",
    "platform.audit.field.metric": "المقياس",
    "platform.audit.field.months": "المدة (أشهر)",
    "platform.audit.field.movedTo": "نُقل إلى",
    "platform.audit.field.name": "الاسم",
    "platform.audit.field.nameAr": "الاسم بالعربية",
    "platform.audit.field.nameEn": "الاسم بالإنجليزية",
    "platform.audit.field.otherSessionsRevoked": "سُجّل الخروج من الأجهزة الأخرى",
    "platform.audit.field.owner": "المسؤول",
    "platform.audit.field.parked": "أُوقف",
    "platform.audit.field.period": "الفترة",
    "platform.audit.field.portalEnabled": "البوابة مفتوحة",
    "platform.audit.field.priority": "الأولوية",
    "platform.audit.field.proposedDueAt": "الموعد المقترَح",
    "platform.audit.field.publishedByAgency": "نشرته الوكالة",
    "platform.audit.field.reason": "السبب",
    "platform.audit.field.recurring": "متكرّر",
    "platform.audit.field.remindersScheduled": "جُدولت تذكيرات",
    "platform.audit.field.revokedApproval": "سُحبت الموافقة",
    "platform.audit.field.role": "الدور",
    "platform.audit.field.sessionsEnded": "أجهزة سُجّل خروجها",
    "platform.audit.field.sizeBytes": "الحجم (بايت)",
    "platform.audit.field.state": "الحالة",
    "platform.audit.field.status": "حالة الحساب",
    "platform.audit.field.steps": "الخطوات",
    "platform.audit.field.stillHeld": "ما زال مستخدماً في مكان آخر",
    "platform.audit.field.subject": "الموضوع",
    "platform.audit.field.tasksMoved": "مهام نُقلت",
    "platform.audit.field.theme": "المظهر",
    "platform.audit.field.timezone": "التوقيت",
    "platform.audit.field.title": "العنوان",
    "platform.audit.field.toColumn": "إلى عمود",
    "platform.audit.field.tone": "اللون",
    "platform.audit.field.person": "الشخص",
    "platform.audit.field.value": "القيمة",
    "platform.audit.field.version": "النسخة",
    "platform.audit.field.visible": "ظاهر للعميل",
    "platform.health.why": "السبب",
    "platform.health.took": "{millis} ملّي ثانية",
    "platform.health.every": "كل {every}",
    "platform.health.showOpen": "المفتوحة",
    "platform.health.showResolved": "المغلقة",
    "platform.health.firstSeen": "أول مرة",
    "platform.health.lastSeen": "آخر مرة",
    "platform.health.operation": "العملية",
    "platform.health.noResolvedTitle": "لا توجد حوادث مغلقة",
    "platform.health.noResolvedBody": "أي حادثة تُغلق ستظهر هنا بتاريخ إغلاقها.",
    "platform.health.allGood": "كل الخدمات تعمل — ولا يوجد ما ينتظر أحداً",
    "platform.health.someIncidents": "كل الخدمات تعمل — وهناك {n, plural, one {حادثة واحدة تنتظر من يراجعها} two {حادثتان تنتظران من يراجعهما} few {# حوادث تنتظر من يراجعها} many {# حادثة تنتظر من يراجعها} other {# حادثة تنتظر من يراجعها}}",
    "platform.health.serviceDown": "توجد خدمة متوقّفة: {names}",
    "platform.health.checkedAgo": "آخر فحص {ago} · يتحدّث تلقائياً كل 30 ثانية",
    "platform.health.checkNow": "افحص الآن",
    "platform.health.services": "الخدمات",
    "platform.health.serviceHint.database": "كل بيانات النظام",
    "platform.health.serviceHint.storage": "الصور والفيديوهات والملفات",
    "platform.health.serviceHint.scanner": "يفحص كل ملف يُرفع",
    "platform.health.serviceHint.mail": "الدعوات وتغيير كلمة السرّ",
    "platform.health.serviceHint.push": "ما يصل إلى الهاتف",
    "platform.health.jobName": "المهمة",
    "platform.health.jobEvery": "يعمل",
    "platform.health.silent": "لا يُصدر إشعارات — هذه طبيعته",
    "platform.health.job.cardRelay": "تذكيرات البطاقات والتصعيد",
    "platform.health.job.recurrenceRelay": "البطاقات المتكرّرة",
    "platform.health.job.exporter": "نسخ بيانات العملاء",
    "platform.health.job.exceptionEscalation": "تصعيد استثناءات المراجعة",
    "platform.health.job.goalRelay": "متابعة الأهداف",
    "platform.health.job.foldRelay": "طيّ القنوات الخاملة",
    "platform.health.job.meetingRelay": "تذكيرات الاجتماعات",
    "platform.health.job.reconciler": "مراجعة التخزين",
    "platform.health.job.dispatcher": "توصيل الإشعارات",
    "platform.health.job.attachmentScanner": "فحص الملفات المرفوعة",
    "platform.notifications.searchHint": "«موعد»، «العميل»…",
    "platform.notifications.english": "بالإنجليزية",
    "platform.notifications.insert": "أضِف:",
    "platform.notifications.insertParam": "+ {name}",
    "platform.notifications.inboxAlways": "صندوق الإشعارات داخل النظام يصله الإشعار دائماً — ولا يمكن إيقافه.",
    "platform.notifications.preview": "سيصل هكذا",
    "platform.notifications.previewNow": "الآن",
    "platform.notifications.previewInbox": "في صندوق الإشعارات",
    "platform.notifications.previewNote": "المعاينة بأسماء تجريبية، لكي ترى الجملة كاملة قبل الحفظ.",
    "platform.notifications.firedBy": "يصدر من: {what}",
    "platform.notifications.cadence": "يصدر تلقائياً {every}",
    "platform.notifications.pickOne": "اختر إشعاراً من القائمة لتعديل نصّه.",
    "platform.notifications.param.count": "العدد",
    "platform.notifications.param.subject": "اسم العنصر",
    "platform.notifications.param.actor": "من قام بالفعل",
    "platform.notifications.param.block": "سبب التوقّف",
    "platform.notifications.param.channel": "اسم القناة",
    "platform.notifications.param.client": "اسم العميل",
    "platform.notifications.param.code": "الرمز",
    "platform.notifications.param.days": "عدد الأيام",
    "platform.notifications.param.decision": "القرار",
    "platform.notifications.param.due": "الموعد",
    "platform.notifications.param.excerpt": "بداية الرسالة",
    "platform.notifications.param.hours": "عدد الساعات",
    "platform.notifications.param.metric": "المقياس",
    "platform.notifications.param.missed": "ما فات",
    "platform.notifications.param.outcome": "النتيجة",
    "platform.notifications.param.percent": "النسبة",
    "platform.notifications.param.platform": "المنصة",
    "platform.notifications.param.reason": "السبب",
    "platform.notifications.param.resolution": "الحل",
    "platform.notifications.param.target": "المطلوب",
    "platform.notifications.param.task": "اسم المهمة",
    "platform.notifications.param.title": "العنوان",
    "platform.notifications.param.value": "الرقم",
    "platform.notifications.param.version": "رقم النسخة",
    "platform.notifications.param.weeks": "عدد الأسابيع",
    "platform.notifications.param.when": "الوقت",
    "platform.notifications.sample.count": "3",
    "platform.notifications.sample.subject": "نصوص صفحة الهبوط",
    "platform.notifications.sample.actor": "شادي سراج",
    "platform.notifications.sample.block": "بانتظار الصور من العميل",
    "platform.notifications.sample.channel": "فريق التصميم",
    "platform.notifications.sample.client": "مينت كافيه",
    "platform.notifications.sample.code": "4821",
    "platform.notifications.sample.days": "3",
    "platform.notifications.sample.decision": "تمّت الموافقة على الاستثناء",
    "platform.notifications.sample.due": "الخميس 5 م",
    "platform.notifications.sample.excerpt": "هل يمكن تغيير لون الخلفية؟",
    "platform.notifications.sample.hours": "24",
    "platform.notifications.sample.metric": "التسليم في الموعد",
    "platform.notifications.sample.missed": "2",
    "platform.notifications.sample.outcome": "اعتُمد",
    "platform.notifications.sample.percent": "80",
    "platform.notifications.sample.platform": "إنستجرام",
    "platform.notifications.sample.reason": "الصورة تحتاج إلى إضاءة أكثر",
    "platform.notifications.sample.resolution": "أُزيل المنشور",
    "platform.notifications.sample.target": "90%",
    "platform.notifications.sample.task": "الغلاف — REEL 4",
    "platform.notifications.sample.title": "تقرير أكتوبر",
    "platform.notifications.sample.value": "85%",
    "platform.notifications.sample.version": "3.2",
    "platform.notifications.sample.weeks": "2",
    "platform.notifications.sample.when": "غداً 11 ص",
    "settings.sections": "أقسام الإعدادات",
    "settings.groupHint.identity": "الاسم واللون واللغة",
    "settings.groupHint.work": "المواعيد والتصعيد",
    "settings.groupHint.plans": "حدّ رفض العميل والاستثناءات",
    "settings.groupHint.storage": "المساحة وحدود الملفات",
    "settings.groupHint.security": "الدخول والتحقّق بخطوتين",
    "settings.groupHint.reports": "مواعيد التقارير",
    "settings.groupHint.retention": "مدة الاحتفاظ والنسخ",
    "settings.unsaved": "غيّرت {n} — غير محفوظ",
    "settings.revert": "تراجع",
    "settings.save": "احفظ",
    "settings.addReminder": "+ تذكير",
    "settings.reminderBefore": "قبله {hours, plural, one {بساعة واحدة} two {بساعتين} few {بـ # ساعات} many {بـ # ساعة} other {بـ # ساعة}}",
    "settings.removeReminder": "أزِل تذكير {hours, plural, one {ساعة واحدة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}}",
    "settings.reminderHours": "كم ساعة قبل الموعد؟",
    "settings.addReminderConfirm": "أضِف",
    "platform.notifications.titleAr": "العنوان بالعربية",
    "platform.notifications.titleEn": "العنوان بالإنجليزية",
    "platform.notifications.bodyAr": "النص بالعربية",
    "platform.notifications.bodyEn": "النص بالإنجليزية",
    "platform.notifications.search": "ابحث في النصوص",
    "actions.title": "المطلوب منك",
    "actions.subtitle": "كل قرار ينتظرك — في مكان واحد. يختفي البند بمجرد أن تنفّذه.",
    "actions.noneTitle": "لا يوجد ما ينتظرك",
    "actions.noneBody": "بمجرد أن يصلك قرار سيظهر هنا، ومعه زرّ يفتحه.",
    "actions.kind.cardDueChange": "طلب تغيير موعد بانتظار قرارك",
    "actions.kind.accessRequest": "طلب صلاحية بانتظار ردّك",
    "actions.kind.reportHead": "تقرير بانتظار مراجعتك كرئيس قسم",
    "actions.kind.reportAdmin": "تقرير بانتظار نشر الإدارة",
    "actions.kind.reportException": "طلب استثناء بانتظار قرارك",
    "actions.kind.revisionException": "عنصر متوقّف على استثناء مراجعة بانتظار قرارك",
    "actions.kind.takedown": "طلب إزالة بانتظار قرارك",
    "actions.kind.meeting": "اجتماع بانتظار ردّك",
    "actions.kind.portalItem": "عنصر بانتظار موافقتك",
    "actions.kind.portalMeeting": "موعد بانتظار ردّك",
    "actions.open": "افتحه",
    "actions.onlyKind": "تعرض فقط: {kind}",
    "actions.onlyKindNone": "لا يوجد ما ينتظرك من هذا النوع الآن.",
    "actions.showAll": "اعرض الكل",
    "actions.defer": "ذكّرني لاحقاً",
    "actions.deferTomorrow": "غداً",
    "actions.deferWeek": "بعد أسبوع",
    "actions.deferUntil": "ذكّرني في",
    "actions.deferred": "أُجّل إلى {until}.",
    "actions.deferredCount": "مؤجَّلة · {count} — تعود تلقائياً في موعدها",
    "actions.wakeNow": "أعِدها الآن",
    "actions.woke": "عاد إلى القائمة.",
    "actions.since": "ينتظر منذ",
    "actions.deferUntilInvalid": "اختر تاريخاً بعد اليوم وفي حدود شهر.",
    "actions.deferPick": "اختر موعداً…",
    "actions.deferredTitle": "المؤجَّلة",
    "actions.returnsAt": "تعود {when}",
    "portal.nav.actions": "المطلوب منك",
    /**
     * **عائلةُ الخيط — مفاتيحُ مكوّنٍ واحدٍ لا مفاتيحُ شاشة.**
     *
     * **وكانت `cards.comment*`** لأن الخيطَ كان في لوحة الكارت وحدها. ولمّا نزل
     * على عنصر الخطة كان الطريقُ إمّا مفاتيحَ ثانيةً بنفس النصّ — **فيفترق
     * النصّان عند أوّل تعديل** — أو عائلةً واحدةً للمكوّن. **فالمفاتيحُ تتبع
     * المكوّنَ لا موضعَه.**
     */
    "thread.title": "التعليقات",
    "thread.empty": "لا توجد تعليقات.",
    "thread.placeholder": "اكتب تعليقاً…",
    "thread.send": "أرسِل",
    "thread.editedTag": "معدَّل",
    "thread.required": "اكتب التعليق.",
    "thread.clientVisible": "في خيط العميل",
    "thread.replyInChat": "هذا الخيط داخلي — لا يرى العميل ردّك هنا. إذا أردت الردّ عليه، فردّ في المحادثات.",
    /**
     * **سطوحٌ نزلت بقرارات شادي 2026-10-20** — الملفاتُ على التعليقات،
     * وملفاتُ التقرير، وحضورُ الاجتماع.
     */
    "meetings.attendees": "من يحضر",
    "meetings.attendeesSaved": "حُفظت قائمة الحضور.",
    "meetings.attendeesNone": "لم يُحدَّد أحد بعد.",
    "meetings.attendeesPick": "اختر من يحضر",
    "reports.files": "ملفات التقرير",
    "reports.filesNone": "لا توجد ملفات مرفقة بالتقرير.",
    "thread.attach": "أرفق ملفاً",
    "notify.reports.commented.title": "تعليق على تقرير",
    "notify.reports.commented.body": "تعليق جديد على تقرير «{title}».",
    "notify.meetings.commented.title": "تعليق على اجتماع",
    "notify.meetings.commented.body": "تعليق جديد على اجتماع «{subject}».",
    "notify.meetings.attendee.title": "أنت من حضور اجتماع",
    "notify.meetings.attendee.body": "أُضفت إلى حضور اجتماع «{subject}».",
    /**
     * **ونوعٌ ثالثٌ لليتيم** (2026-10-24): مفتاحٌ في القاعدة **خارج كلِّ درجٍ
     * تسرح فيه المصالحة** — فلا يُقال ناقصاً ولا سليماً، يُقال إنه خارج ما نعرف.
     */
    "storage.orphans.unknownSpace": "مفتاح خارج المساحات المعروفة",
    "storage.orphans.unknownKind": "نوع غير معروف",
    "storage.title": "التخزين",
    "storage.subtitle": "مساحة كل عميل، والملفات التي ليس لها صاحب.",
    "storage.usedTotal": "إجمالي المستهلك",
    "storage.nearest": "العميل الأقرب إلى حدّه",
    "storage.nearestNone": "لا يوجد عملاء",
    "storage.nearestValue": "{name} {percent}%",
    "storage.nearestCalm": "لا يوجد — أعلاهم {name} {percent}%",
    "storage.orphans.tile": "ملفات يتيمة",
    "storage.orphans.tileValue": "{n} · {size}",
};
//# sourceMappingURL=ar.js.map